export default {
  alternatescreenname: "Alternate Screen Name",
  alternatecinemaname: "Alternate Cinema Name Language",
  alternatecinemaaddress: "Alternate Cinema Address Language",
  alternate_cinemaName: "Cinema name in alternate language",
  alternate_cinemaAddress: "Cinema address in alternate language",
  alternate_ScreenName: "Screen name in alternate language",
  alternate_movieName: "Also Known As (Alternate Name)",
  alternatemoviename: "AKA",
  alternatelangname: "Alternate Language Name",
  alternateAddOnName: "Alternate Add-on Name Language",
  alternate_langName: "Language name in alternate language",
  isocode2: "ISO 2",
  isocode3: "ISO 3",
  id: "ID",
  version: "Version",
  secretcode: "Token",
  received: "Received Inward",
  org_id: "Organization",
  cine_code: "Cinema Code",
  cine_name: "Cinema Name",
  alternate_cinema_name_language: "Alternate Cinema Name Language",
  cinema_type_id: "Cinema Type",
  cinema_classification_id: "Cinema Classification",
  cine_location: "Location",
  cine_address: "Address",
  city_name: "City",
  state_id: "State",
  country_id: "Country",
  cine_pincode: "Zip Code",
  region_id: "Region",
  territory_id: "Territory",
  cine_license_number: "Licence",
  cine_registration_number: "Regestration Number",
  cine_latitude: "Latitude",
  cine_longitude: "Longitude",
  alternate_cinema_address_language: "Alternate Cinema Address Language",
  preferred_language_id: "Preferred Language",
  cine_image_url: "Upload Image",
  currency_id: "Currency",
  tier_type_id: "Tier Type",
  location_type_id: "Location Type",
  cine_email: "Email Address",
  cine_screens: "No of Screens",
  minimumstocklevel: "Minimum Stock Level",
  isExpiryavailable: "Is Expiry Available",
  isPackageitem: "Is Package Item",
  chargetype: "Charge Type | Charge Types",
  mf_name: "Movie Format | Movie Formats",
  production_name: "Production Company | Production name",
  authentication: "Authentication",
  customizationreport: "Customization Report",
  addonsreport: "Add Ons Report",
  multifnb: "Multi F&B",
  refresh: "Refresh",
  shifthours: "Shift Hours",
  shiftstartime: "Shift Start Time",
  shiftendtime: "Shift End Time",
  blockSeat: "Block Seat",
  manageYourWebBannersHere: `Manage All your Web Banners here.`,
  generatemorevouchers: "Generate & Add More Vouchers",
  Fnbtransactions: "F&B Transactions",
  ponumber: "PO Number",
  typeofaudit: "Type of Audit",
  field: "Field",
  original: "Original",
  fnbauditlogs: "Audit Logs",
  paymenttypeswisesalesreport: "Payment Typewise Sales Report",
  scheduleauditlogs: "Schedule Audit Logs",
  systemLogs: "System Logs",
  expiryreport: "Expiry Report",
  respond: "Respond",
  subject: "Subject",
  supportticketing: "Support Ticket",
  supportticketcategory: "Support Ticket Category",
  ipaddressrange: "IP Address Range",
  movieanalytics: "Movie Analytics",
  openall: "Open all Schedules",
  openindividual: "Open Individual",
  deleteindividual: "Delete Individual",
  plannedschedule: "Planned Schedule",
  invoice_selectCinema: "Select cinema for invoice",
  invoic_netamount: "Enter a invoice net amount",
  invoice_taxamount: "Enter a invoice tax amount",
  to: "To",
  sms: "SMS",
  points: "Points",
  emailtemplate: "Email Template",
  smstemplate: "SMS Template",
  totalpoints: "Total Points",
  customerloyaltyponits: "Customer Loyalty Points",
  signagemoviemapping: "Signage Mapping",
  minimumpointsearnings: "Minimum Earning Points",
  maximumpointsearnings: "Maximum Earning Points",
  earnpointsondicount: "Earn Points on Discount",
  burnpointsondicount: "Burn Points on Discount",
  pointsrequired: "Points Required",
  multiplepoints: "Points Multiplier",
  bonuspoints: "Bonus Points",
  initialamount: "Initial Amount",
  loyaltysettings: "Loyalty Settings",
  global: "Global",
  notificationslog: "Notification Logs",
  notificationtitle: "Notification Title",
  notificationsmsg: "Notification Message",
  notificationstype: "Notification Type",
  notificationread: "Notification Readed",
  frequency: "Frequency",
  EnterMessage: "Enter Message",
  invoice: "Invoice",
  invoiceorderdate: "Invoice Date",
  invoiceorderlock: "Invoice Lock",
  directsale: "F&B Direct Sale",
  parentdistributor: "Parent Distributor",
  shiftclose: "Shift Close",
  receipts: "Receipts",
  release: "Release Seat",
  receiptstemplates: "Receipt Templates",
  selectfile: "Select File",
  selectafile: "Please Select a File",
  seatorder: "Order",
  SeatType: "Seat Type",
  generatebill: "Generate Bill",
  noofpos: "No. of POS",
  kiosk: "No. of Kiosk",
  noofsignage: "No. of Signage",
  fnbcounter: "F & B Counter",
  department_name: "Department",
  employeecode: "Employee code",
  select_user_Department: "Please Select Department",
  select_user_Cinema: "Please select cinema",
  select_user_Designation: "Please Select Designation",
  select_user_Roles: "Please Select Role",
  user_select_Country: "Please Select Country",
  user_select_State: "Please Select State",
  selectgender: "Please Select Gender",
  selectemptype: "Please Select Employement Type",
  selectmachine: "Machine",
  confirm: "Confirm",
  cinemacode: "Cinema Code",
  mobilecode: "Mobile Code",
  resend: "Resend",
  confirmpassword: "Confirm Password",
  fnbitem: "F&B Item",
  recipeoptional: "Recipe Optional",
  itemcostprice: "Cost Price",
  NoRecords: "No Records Found",
  designation: "Designation | Designations",
  add: "Add",
  orgcinema: "No of Cinema",
  proceedtocheckout: "Proceed to Checkout",
  listofall: "List of all",
  incinematic: "In Nuvio",
  viewing: "Viewing",
  of: "Of",
  admin: "Admin",
  status: "Status",
  edit: "Edit",
  view: "View",
  rawmaterials: "Raw Material | Raw Materials",
  active: "Active",
  list: "List | Lists",
  blankfieldmsg: "This field cannot be blank",
  titleempty: "Title cannot be empty",
  update: "Update",
  reset: "Reset",
  code: "Code",
  isocode: "ISO Code",
  statecode: "State Code",
  cancel: "Cancel",
  details: "Detail | Details",
  createdby: "Created By",
  createdat: "Created At",
  updatedat: "Updated At",
  updatedby: "Updated By",
  modifiedby: "Modified By",
  modifiedat: "Modified At",
  stateprovince: "State/Province",
  save: "Save",
  saveaddmore: "Save & Add",
  home: "Home",
  master: "Master | Masters",
  bookingdiscount: "Booking Discount | Booking Discounts",
  movie: "Movie | Movies",
  schedule: "Schedule | Schedules",
  aggregator: "Aggregator | Aggregators",
  recipe: "Recipe | Recipes",
  subrecipe: "Sub Recipe | Sub Recipes",
  bookingsource: "Booking Source | Booking Sources",
  authorizedBy: "Authorized By",
  hslocation: "Hardware Location",
  bs_hslocation: "Booking Location",
  cinema: "Cinema",
  setting: "Setting | Settings",
  backup: "Backup | Backups",
  charge: "Charge | Charges",
  chargesetting: "Charge Setting",
  type: "Type | Types",
  country: "Country",
  countrycode: "Country Code",
  city: "City | Cities",
  territory: "Territory | Territories",
  region: "Region | Regions",
  cinema_type: "Cinema Type | Cinema Types",
  location_type: "Location Type | Location Types",
  cinema_classification: "Cinema Classification | Cinema Classifications",
  tier_type: "Tier Type | Tier Types",

  crew: "Crew | Crews",
  currency: "Currency | Currencies",
  denomination: "Denomination | Denominations",
  distributor: "Distributor | Distributors",
  subdistributor: "Sub-Distributor",
  feature: "Feature | Features",
  fb: "F&B | F&B",
  fnb: "Food & Beverage | Food & Beverages",
  price: "Price | Prices",
  configuration: "Configuration | Configurations",
  food: "Food | Food",
  category: "Category | Categories",
  gender: "Gender | Gender",
  genre: "Genre | Genre",
  hardware: "Hardware | Hardwares",
  language: "Language | Languages",
  marital: "Marital | Marital",
  maritalstatus: "Marital Status | Marital Status",
  module: "Module | Modules",
  modules: "Module",
  format: "Format | Formats",
  payment: "Payment | Payments",
  mode: "Mode | Modes",
  ticket: "Ticket | Tickets",
  refund: "Refund | Refunds",
  reason: "Reason | Reasons",
  role: "Role | Roles",
  seat: "Seat | Seats",
  reservation: "Reservation | Reservations",
  shift: "Shift | Shifts",
  signage: "Signage | Signages",
  signageurl: "Signage URL | Signages URL",
  state: "State | States",
  unitofmeasurement: "Unit of Measurement | Unit of Measurements",
  vendor: "Vendor | Vendors",
  weekday: "Weekday | Weekdays",
  daysactive: "Days Active",
  ho: "HO | HO",
  headoffice: "Head Office | Head Office",
  productioncompany: "Production Company | Production Companies",
  name: "Name",
  inprint: "Inprint",
  sistercompany: "Sister Company",
  contactno: "Contact Number",
  website_url: "Website URL",
  faxno: "Fax Number",
  emailid: "Email Address",
  primaryemailid: "Primary Email",
  extraemailid: "Emails (Optional, comma separated)",
  emailaddress: "Email Address",
  tinnumber: "TIN/UID Number",
  noof: "No Of",
  employee: "Employee",
  taxnumber: "Tax number",
  taxtype: "Tax/VAT",
  taxtypephld: "Select Movie Format",
  address: "Address",
  more: "More",
  imagesettingname: "Image Setting Title",
  imagesetting: "Image Setting | Image Settings",
  height: "Height",
  width: "Width",
  ratio: "Ratio",

  // manage: 'manage',
  // manager: 'manager',

  // NEWLY ADDED BY JAY
  trailer: "Trailer | Trailers",
  poster: "Poster | Posters",

  // NEWLY ADDED BY AKASH
  releasedate: "Release Date",
  originalreleasedate: "Original Release Date",
  runtime: "Run Time",
  nameofperson: "Name Of the person",
  order: "Order",
  distribution: "Distribution",
  distributorContract: "Distributor Contract",
  content: "Content",
  moviesearch: "Movie Search",
  production: "Production",
  rate: "Rate",
  ratePerItem: "Rate Per Item",
  netRate: "Net Rate",
  description: "Description",
  usedfor: "Used For",
  receipt_name: "Reciept Name",
  contract_start_date: "Contract Start Date",
  contract_end_date: "Contract End Date",
  apiid: "API ID",
  authentcationcode: "Authentication Code",
  authentcation_code_tooltip: "Authentication Code",
  username: "Username",
  password: "Password",
  ingredient: "Ingredients",
  quantity: "Quantity",
  Category: "Category",
  selectusercategory: "Select User Category",
  discount: "Discount",
  registration: "Registration No",
  license: "License",
  contact: "Contact",
  pincode: "Zip Code",
  latitude: "Latitude",
  longitude: "Longitude",
  screen: "Screen | Screens",
  operationtime: "Operation Time",
  operationstarttime: "Operation Start Time",
  operationendtime: "Operation End Time",
  cinemaconessionlevel: "Cinema Concession Level",
  language: "Language",
  onlinevisibility: "Online Visibility",
  sellinboxoffice: "Sell F&B in Box Office",
  sellinonline: "Sell F&B Online",
  cleaningtime: "Cleaning Time",
  cleaningstarttime: "Cleaning Start Time",
  // operationstarttime:'Operation Start Time',
  operationendtime: "Operation End Time",
  intervaltime: "Interval Time",
  intermissiontime: "Intermission Time",
  mycinema_creation_interval_time: "MyCinema Creation Interval Time",
  ondemand_creation_interval_time: "OnDemand Creation Interval Time",
  intervalduration: "Interval Duration",
  intermissionduration: "Intermission",
  cutofftime: "Cut Off Time",
  advertisementtime: "Advertisement Time",
  seatreleasetime: "Seat Release Time",
  english: "English",
  arabic: "Arabic",
  spanish: "Spanish",
  currencycode: "Currency Code",
  isfirstdayoftheweek: "Is First Day Of The Week",
  weekdayisoff: "Is Week Off",
  parent: "Parent",
  workinghour: "Working Hours",
  starttime: "Start Time",
  endtime: "End Time",
  applicableto: "Applicable to",
  categoryname: "Category Name",
  backuplocationbrowse: "Backup Location Browse",
  provideavalidname: "Provide a valid pathname",
  daily: "Daily",
  select: "Select",
  selection: "Selection",
  howlongbackuptokeep: "How Long Backup To Keep",
  selectdateandtime: "Select Date & Time",
  monthly: "Monthly",
  yearly: "Yearly",
  fortnight: "Fortnight",
  weekly: "Weekly",
  backuprestore: "Backup Restore",
  rating: "Ratings",
  selected: "Selected",
  plot: "Plot",
  trailerlink: "Trailer Link",
  imageurl: "Image URL",
  value: "Value",
  fromdate: "From Date",
  todate: "To Date",
  fromtime: "From Time",
  totime: "To Time",
  time: "Time",
  gold: "Gold",
  silver: "Silver",
  tax: "Tax",
  taxamount: "Tax Amount",
  receipename: "Select Recipe",
  invalidentry: "Invalid Entry",
  hardwareuniquecode: "Hardware Unique Code",
  noteremarks: "Notes / Remarks",
  connectionport: "Connection Port",
  authenticationcode: "Authentication Code",
  key: "Key",
  tooltip: "Enter sales price for F&B item",
  customization_salesPrice_tooltip: "Sales Price for an item",
  starttime: "Start Time",
  endtime: "End Time",
  sun: "Sun",
  mon: "Mon",
  tue: "Tue",
  wed: "Wed",
  thu: "Thu",
  fri: "Fri",
  sat: "Sat",
  user: "User | Users",
  shiftstartdate: "Shift Start Date",
  shiftenddate: "Shift End Date",
  login_date_time: "Login Date Time",
  logout_date_time: "Logout Date Time",
  sharetype: "Share Type",
  cinemaname: "Cinema Name",
  backuptype: "Backup Type",
  backuptime: "Backup Time",
  report: "Report",
  middlename: "Middle Name",
  lastname: "Last Name",
  dob: "Date Of Birth",
  doj: "Date Of Joining",
  zipcode: "Zip Code",
  phone: "Phone",
  mobiles: "Mobile",
  employeeid: "Employee ID",
  employeetype: "Employment Type",
  no: "No.",
  access: "Access",
  forgot: "Forgot",
  signin: "Sign In",
  change: "Change",
  old: "Old",
  enternew: "Enter New",
  confirmnew: "Confirm New",
  update: "Update",
  forgot: "Forgot",
  email: "Email",
  alert: "Alert",
  alertthreshold: "Alert threshold (quantity)",
  vendormapping: "Mapeo de proveedores",
  generatepurchaseorder: "Generate Purchase Order",
  pricelabel: "Price Label",
  amount: "Sales Price",
  order_value: "Order Value",
  floatAmount: "Float Amount",
  netSalesPrice: "Net Sales Price",
  allbooking: "All Booking",
  searchbooking: "Search Booking",
  search: "Search",
  datetime: "Date & Time",
  booking: "Booking",
  confirmationid: "Confirmation ID",
  paymentsummary: "Payment Summary",
  vendormapping: "Vendor Mapping",
  submit: "Submit",
  platinum: "Platinum",
  startdate: "Start Date",
  enddate: "End Date",
  showenddate: "Show End Date",
  ratecard: "Rate Card",
  inclusivoftax: "Inclusive Of Tax",
  calculatesplit: "Calculate Split",
  clientlogo: "Client-logo",
  organisationlogo: "Organisation-logo",
  oganization: "Organization",
  setupdate: "Setup Date",
  launchdate: "Launch Date",
  isPercentage: "Percentage",
  Percentage: "Percentage",
  isRebate: "Rebate/Discount",
  isAddition: "Is Addition",
  isTaxable: "Is Taxable",
  grossAmount: "Gross amount",
  netAmount: "Net amount",
  share: "Share",
  shareValue: "Share Value",
  sharelabel: "Share Label",
  fixedValueToTheatre: "Fixed Value To Theatre",
  isPercentageValue: "Is Percentage Value",
  contract: "Contract",
  weekwise: "Week Wise",
  fixedValueShare: "Fixed Value Share",
  percentgeOf: "Percentage Of",
  duration: "Duration",
  floatAmount: "Float amount",
  enable: "Enable",
  date: "Date",
  imagesettingname: "Image setting name",
  quantityAlert: "Quantity Alert",
  stockAlert: "Stock Alert",
  chargesettingname: "Charge Setting",
  ratedCardName: "Rated Card Name",
  operation: "Operation",
  showtime: "Show Time",
  refundReasons: "Refund Reasons",
  selectConcessionLevel: "Select Concession Level",
  purchase: "Purchase",
  items: "Items",
  item: "Item",
  totalamount: "Total Amount",
  purchaseorderdate: "Purchase Order Date",
  purchaseorderlock: "Purchase Order Lock",
  isdefaultvendor: "Is Default Vendor",
  deparmentcode: "Department Code",
  isperishable: "Is perishable",
  rm_rte: "Ready To Eat",
  recco: "Recco",
  rawmaterial: "Raw Material",
  foodcategoryname: "Food Category Name",
  parentfoodcategoryname: "Parent Food Category",
  foodorder: "Order in Pos",
  profile: "Profile",
  isparent: "Is Parent",
  expiry: "Expiry",
  days: "Days",
  recipeiscombo: "Recipe is combo",
  fnbitems: "F&B item",
  recipename: "Recipe Name",
  itemname: "Item Name",
  itemcode: "Item Code",
  foodcategory: "Food Category",
  uploadfoodimage: "Upload Food Image",
  isveg: "Veg",
  usersshift: "User Shift",
  start: "Start",
  end: "End",
  in: "In",
  date: "Date",
  concessionstock: "Concession Stock",
  concession: "Concession",
  fnbPricing: "F&B Pricing",
  fnbWastage: "F&B Wastage",
  accountableuser: "Account Able User",
  approvedby: "Approved By",
  fineamount: "Fine Amount",
  netamount: "Net Amount",
  grossamount: "Gross Amount",
  concessionLevel: "Concession Level",
  orderNo: "Order No",
  stockinQuantity: "Quantity to inward",
  cash: "Cash",
  given: "Given",
  all: "All",
  release: "Release",
  running: "Running",
  action: "Action",
  adventure: "Adventure",
  scifi: "Sci-fi",
  castCrew: "Cast & Crew",
  synopsis: "Synopsis",
  creditDebit: "Credit & Debit Card",
  cashlessPayment: "Cashless Payment",
  splitPayments: "Split Payments",
  couponPromotion: "Coupon Promotion",
  voucher: "Vouchers",
  loyaltyCard: "Loyalty Card",
  payBy: "Pay By",
  number: "Number",
  idNumber: "ID Number",
  additionalChanges: "Additional Charges",
  debitNcreditCard: "Debit Card / Credit Card",
  occupancy: "Occupancy",
  close: "Close",
  book: "Book",
  pickup: "Pickup",
  damage: "Damage",
  roll: "Roll",
  new: "New",
  checkout: "Checkout",
  back: "Back",
  admits: "Admits",
  unpaid: "Unpaid",
  available: "Available",
  done: "Done",
  print: "Print",
  reprint: "Reprint",
  image: "Image",
  enter: "Enter",
  proceed: "Proceed",
  addDirectlyToStore: "Add Directly To Store",
  unit: "Unit",
  subtotal: "Subtotal",
  shipping: "Shipping",
  iscountable: "Is Countable",
  uploadimage: "Upload Image",
  preferred_language_id: "Preferred Language",
  d_company_name: "Distributor",
  uploaduserimage: "Upload User Image",
  collection: "Collection",
  film: "Film",
  wise: "Wise",
  sale: "Sales",
  ratings: "Ratings",
  uom: "UOM",
  transferred: "Transfer | Transferred",
  in: "In",
  love: "Love",
  recliner: "Recliner",
  wheelchair: "Wheel Chair",
  onlyPos: "Only POS",
  taken: "Taken",
  your: "Your",
  full: "Full",
  exit: "Exit",
  screen_title: "All Eyes This Way",
  skip: "Skip",
  total: "Total",
  vipSeat: "VIP Seat",
  regularSeat: "Regular Seat",
  noSeat: "No Seat",
  sofa: "Sofa",
  LoveSeat: "Love Seat",
  reports: "Reports",
  rolemanagement: "Role Management",
  departmentid: "Department ID",
  type: "Type",
  dol: "Date of Leaving",
  Renunciation: "Renunciation",
  rol: "Reason for Leaving",
  verificationtype: "Verification Type",
  uploadbinnumbers: "Upload Bin Number File",
  uploadbanklogo: "Upload Bank Logo",
  bank: "Bank",
  weekdaymsg: "please select atleast one day",
  applicablemsg: "please select atleast one applicable type checkbox",
  redeematmsg: "please select atleast one reedem at checkbox",
  yes: "YES",
  // no: "NO",
  institution: "Institution",
  offertypes: "Offer Types",
  offer: "Offer",
  customercode: "Customer Code",
  customer: "Customer",
  marketingtype: "Marketing Type",
  cardtype: "Card Type",
  bankmsg: "Please select Bank ",
  mobileno: "Contact Number",
  marketTypemsg: "Please Select Marketing Type",
  weekends: "Weekends",
  binNumbers: "Bin Numbers",
  upload: "Upload",
  customer: "Customer | Customers",
  anniversary: "Anniversary",
  verified: "Verified",
  customerisactive: "Customer is Active",
  icon: "Icon",
  concession: "Concession",
  concession_name: "Concession Name",
  promotionsandoffer: "Promotions & Offers",
  title: "Title",
  redemptionOutlet: "Redemption Outlet",
  canavailonline: "Can avail Online",
  availatboxoffice: "Avail at Box Office",
  availatconcession: "Avail at Concession",
  offerconfiguration: "Offer Configuration",
  applicableforparticularmovie: "Applicable for particular movie",
  applicableforspecificdaysdatetime: "Applicable for specific Days, Date, Time",
  applicableforselectedcinemasnclasses:
    "Applicable for selected Cinemas & Classes",
  applicableforselectedcinemasclassesntickettypes:
    "Applicable for selected Cinemas, Classes & Ticket Types",
  buyngetfreeticket: "Buy & Get Free Ticket",
  buy: "Buy",
  get: "& get",
  ofticketsfree: "of tickets free",
  minimumticketpurchase: "Minimum ticket purchase",
  maximumfreeticketpertransaction: "Maximum free ticket per transaction",
  maxmumfreeticketpertransaction: "Maximum free ticket per transaction",
  maxfreeticketpertransaction: "Max free ticket per transaction",
  cancombinewithotheroffers: "Can combine with other offers",
  discounts: "Discounts",
  maxdiscountpertransaction: "Max discount per transaction",
  cancombinewithotheroption: "Can combine with other option",
  buyandgetcombo: "Buy & Get Combo",
  offerapplicableat: "Offer applicable at",
  customercategoryoffer: "Customer Category Offer",
  student: "Student",
  corporate: "Corporate",
  validateby: "Validate By",
  offerprice: "Offer Price",
  specialInstruction: "Special Instruction",
  specialinstructonregardingoffer: "Special Instruction Regarding Offer",
  promocode: "Promo Code",
  send: "Send",
  applicablefor: "applicable for",
  transactions: "Transactions",
  transaction: "Transaction",
  show: "Show",
  showCancelReason: "Show Cancel Reason",
  vouchersissuedbypartnername: "Vouchers issued by Partner Name",
  noofvoucherstobegenerated: "No of Vouchers to be generated",
  isValueVoucher: "Value Voucher",
  foramount: "for amount",
  redemptionvalidfrom: "Redemption valid from",
  termsandconditions: "Terms & Conditions",
  generate: "Generate",
  generated: "Generated",
  loyalty: "Loyalty",
  program: "Program",
  level: "Level",
  minimumpointsforredemption: "Minimum points for redemption",
  maximumpointstoberedeemedpertransaction:
    "Maximum points to be redeemed per transaction",
  requirementtoenroll: "Requirement to enroll",
  age: "Age",
  proof: "Proof",
  eligibilitytoenroll: "Eligibility to enroll",
  earnpoints: "Earn Points",
  pointsfromamount: "points from amount",
  spent: "Spent",
  burnpoints: "Burn Points",
  earnpointsonlyonnondiscountedamount:
    "Earn Points only on non discounted amount",
  eligiblewithotheroffers: "Eligible with other offers",
  eligibleforfreetickets: "Eligible for free tickets",
  ticketsper: "Tickets per",
  showpriority: "Show Priority",
  prepaidcard: "Prepaid Card",
  cardname: "Card Name",
  cardserialnostart: "Card Serial No Start",
  cardserialnoends: "Card Serial No Ends",
  cardvalidityfromdate: "Card Validity from Date",
  cardexpirydate: "Card Expiry Date",
  loadamount: "Load amount",
  getextra: "get extra",
  maxloadamount: "max load amount",
  maxextraamount: "max extra amount",
  freemovieoffer: "Free Movie Offer",
  watch: "Watch",
  free: "Free",
  spendamount: "Spend amount",
  for: "for",
  moviesandget: "movies and get",
  moviesfree: "Movies free",
  inmins: "in mins",
  useallloyaltyofferswiththiscard: "Use all Loyalty offers with this card",
  loyaltycustomer: "Loyalty Customer",
  selectloyaltyprogram: "Select Loyalty Program",
  initialloadamt: "Initial Load Amt",
  balance: "Balance",
  joinedprogramon: "Joined Program on",
  expirydateifany: "Expiry Date (If Any)",
  noofticketpurchased: "No Of Ticket Purchased",
  noffamountsaved: "No Of Amount Saved",
  storemanagement: "Store management",
  documentvarification: "Document Verification",
  document: "Document",
  toverify: "To verify",
  unitconverter: "Unit Converter",
  cinematemplate: "Cinema Ticket Templates",
  autoemailreport: "Auto Email Report",
  autoemailreportv2: "Auto Email Report V2",
  tickettemplates: "Ticket Templates",
  templates: "Template",
  copies: "No. of copies",
  template: "Template",
  single: "Single",
  support: "Support",
  include: "Include",
  separate: "Separate",
  bill: "Bill",
  specialinstruction: "Special Instruction",
  releaseseat: "Release Seat",
  sold: "Sold",
  usage: "Usage",
  distributorDeduction: "Distributor Deduction",
  week: "Week",
  deduction: "Deduction",
  summary: "Summary",
  admit: "Admits",
  revenue: "Revenue",
  average: "Average",
  per: "Per",
  net: "Net",
  gross: "Gross",
  goods: "Goods",
  cost: "Cost",
  spend: "Spend",
  head: "Head",
  admission: "Admission",
  strike: "Strike",
  profit: "Profit",
  margin: "Margin",
  standard: "Standard",
  download: "Download",
  performancereport: "Performance Report",
  performance: "Performance",
  gcamreport: "GCAM Report",
  gcam: "GCAM",
  gcamfees: "GCAM Fees",
  showdate: "Show Date",
  buisnessdate: "Business Date",
  fetch: "Fetch",
  fetchDetails: "Fetch Details",
  audience: "Audience",
  films: "Films",
  capacity: "Capacity",
  service: "Service",
  charge: "Charge",
  dailysalesreport: "Daily Sales Transaction Report",
  occupancyreport: "Occupancy Report",
  outlet: "Outlet",
  patners: "Patners",
  grand: "Grand",
  wise: "Wise",
  partner: "Partner",
  current: "Current",
  advance: "Advance",
  today: "Today",
  card: "Card",
  creditcard: "Credit Card",
  prepaid: "Prepaid",
  class: "Class",
  screenwisecollectionreport: "Screen Wise Collection Report",
  system: "System",
  physical: "Physical",
  variance: "Variance",
  stocktakeLogs: "Stock Take Logs",
  calculate: "Calculate",
  login: "login",
  logout: "Logout",
  userAuditLog: "User Audit Log",
  goodreturn: "Goods Return",
  returnable: "Returnable",
  combinewith: "Combine with",
  municipality: "Municipality",
  reserveseats: "Reserve Seats",
  filmwisecollectionreport: "Film wise collection report",
  screencollectionreport: "Screen Wise Collection Report",
  distributorcollectionreport: "Distributor Collection Report",
  aggregatorsReport: "Aggregators Report",
  aggregatorsTransactionReport: "Aggregators Transactions Report",
  aggregatorsDailySalesReport: "Aggregators Daily Sales Report",
  advancesalesreport: "Advance Sales Report",
  hourlysphReport: "Hourly SPH Report",
  recipeReport: "Recipe Report",
  fastmovingreport: "Fast Moving Report",
  concessiondailyReport: "Concession Daily Report",
  cogsReport: "COGS Report",
  grnReport: "GRN Report",
  stockwastageReport: "Stock Wastage Report",
  dailyPerishableMovement: "Daily Perishable Movement",
  currentStockReport: "Current Stock Report",
  municipalityReport: "Municipality Report",
  customer: "Customer",
  marketing: "Marketing",
  supplier: "Supplier",
  remarks: "Remarks",
  entered: "Entered",
  getReport: "Get Report",
  reference: "Reference",
  fillingfast: "Filling Fast",
  housefull: "House Full",
  transferStock: "Transfer Stock",
  transferStockLogs: "Transfer Stock Log",
  generatemultiplecode: "Generate Multiple Code",
  enterPrefix: "Enter Prefix",
  random: "Random",
  sequence: "Sequence",
  entercodelength: "Enter Code Length",
  codelength: "Code Length",
  transferfromstore: "Transfer From Store",
  transfertostore: "Transfer to Store",
  transfer: "Transfer",
  by: "By",
  shiftworkinghours: "Working Hours",
  shift_working_hrs: "Working Hours",
  shift_is_fnb: "Shifts for Fnb",
  shiftisboxoffice: "Shifts for box office",
  apiversion: "apiversion",
  aggregator_user: "Aggregator user",
  hasparent: "Has parent",
  token: "Token",
  installby: "Install By",
  accerssrightforschedule: "Access Rights For Schedule",
  accerssrightforfnb: "Access Rights For Food & Beverages",
  grn: "GRN",
  adjustment: "Adjustment",
  process: "Process",
  po: "PO",
  create: "Create",
  MaximumDiscountPerTransaction: "Max Discount Per Transaction",
  cinematypes: "Cinema Types",
  tiertypes: "Tier Types",
  //page: addCashCard
  cash_card_number: "Enter Cash Card No.",
  selected_customer: "Select Customer name",
  initial_amount: "Please enter initial amount",
  credited_by: "Amount credited by",
  //page: addSeo
  page_name: "Please select page name",
  seo_meta_title: "Enter meta title",
  seo_meta_description: "Enter meta description",
  seo_meta_keywords: "Enter meta keywords",
  og_type: "Enter Open Graph Type",
  og_site: "Enter Open Graph Site",
  //page:addDistributor
  distributorState_tooltip: "The state where distributor is located",
  addDistributor_iban_tooltip: "Add IBAN NO of the distributor",
  iban_no: "IBAN",
  // bookingusercategorys: 'booking user category',

  // //Menu items
  cinemasettings: "Cinema Settings",
  backupsettings: "Backup Settings",
  chargetypes: "Charge Types",
  fnbconfig: "F&B Configurations",
  fnbprice: "F&B Price",
  foodcategories: "Food Categories",
  martialstatus: "Marital Status",
  movieformat: "Movie Format",
  paymentmode: "Payment Mode",
  ticketpriceconfiguration: "Ticket Price Configuration",
  ticketprice: "Ticket Price",
  refundreason: "Refund Reasons",
  seatreservationtype: "Seat Reservation Type",
  moviecategory: "Movie Category",
  signagetype: "Signage Type",

  //Master dashboard descriptions
  unpaid_booking_dash_msg: "List of all Unpaid Bookings",
  user_dash_msg: "List of the users",
  aggregatoruser_dash_msg: "List of the aggregator users",
  macsettings_dash_msg: "MACCS Settings",
  signages_display_list: "Signages Display List",
  renunciation_dash_msg: "List of employees who have renunciated",
  userAuditLog_dash_msg: "List of user audit logs",
  notificationlog_dash_msg: "List of notification logs",
  shiftclose_dash_msg: "Details about the shifts of the users",
  checklists_dash_msg: "Manage All your Checklists here  ",
  feedback_dash_msg: "Manage your Feedback Forms here ",
  // schedule_dash_msg: 'List of all movies schedules',
  cinema_dash_msg: "List of cinema with cinema settings",
  screen_dash_msg: "List of screens for the cinemas",
  seattype_dash_msg: "List of all seat types",
  screentype_dash_msg: "List of all Screen Types",
  screensize_dash_msg: "List of all Screen Size Formats",
  seatlayout_dash_msg: "List of cinema screen seat layout",
  chargesettings_dash_msg: "List of all Charge Settings",
  ratecard_dash_msg: "List of all rate cards",
  ratecardgroup_dash_msg: "List of all rate card groups",

  movielicense_dash_msg: "List of movie license",
  mycinema_dailysales_report_dash_msg: "Daily sales report of mycinema",
  mycinema_transaction_report_dash_msg: "Transaction report of mycinema",
  cinemaschedulelist_dash_msg: "List of cinema schedule",
  mycinemacinemaschedule_dash_msg: "Add Schedule in MyCinema",
  category_dash_msg: "List of all categories",
  myfestivalmovies_dash_msg: "List of all Movies Categories",
  AccessControlList_dash_msg: "Grant access to user based in permission",
  email_dash_msg: "List of marketing email campaigns",
  sms_dash_msg: "List of marketing sms campaigns",
  userjourney_dash_msg: "List of user journey",
  segments_dash_msg: "List of segments",
  pages_dash_msg: "List of website pages",
  promotionsandoffer_dash_msg: "List of Promotions and offers",
  voucher_dash_msg: "List of voucher",
  customerloyaltypoints_dash_msg: "List of customer loyalty points",
  cinemaloyaltysetting_dash_msg: "List of cinema loyalty settings",
  bank_dash_msg: "List of Banks",
  institution_dash_msg: "List of institution",
  offertypes_dash_msg: "List of offer types",
  binnumbers_dash_msg: "List of card type bin numbers",
  customer_dash_msg: "List of customers",
  cardtype_dash_msg: "List of card type",
  globalloyaltysettings_dash_msg: "List of Global Loyalty Settings",
  FandBAnalytics_dash_msg: "View F&B Analytics Report",
  sharetype_dash_msg: "List of Distributor Share Type",

  manage: "Manage",
  manager: "Manager",
  //Menu items
  cinemasettings: "Cinema Settings",
  backupsettings: "Backup Settings",
  chargetypes: "Charge Types",
  fnbconfig: "F&B Configurations",
  fnbprice: "F&B Price",
  foodcategories: "Food Categories",
  martialstatus: "Marital Status",
  movieformat: "Movie Format",
  paymentmode: "Payment Mode",
  ticketpriceconfiguration: "Ticket Price Configuration",
  ticketprice: "Ticket Price",
  refundreason: "Refund Reasons",
  seatreservationtype: "Seat Reservation Type",
  moviecategory: "Movie Category",
  signagetype: "Signage Type",
  rawmaterialsCategories: "Raw Material Categories",
  rawmaterialcategories: "Raw Material Categories",
  inward: "Inventory inward",
  poinward: "PO Inward / GRN",
  stocktake: "Stock Take",
  makeARefund: "Make A Refund",
  showrefund: "Show Refund",
  customerloyaltypoints: "Customer Loyalty Points",
  paymentOptions: "Payment Options",

  //Master dashboard descriptions
  movie_dash_msg: "List of all movies & their description in Nuvio.",
  schedule_dash_msg: "All movie schedules for each screen in a cinema.",
  plannedschedule_dash_msg:
    "List of all planned movie schedules for each screen in a cinema",
  aggregator_dash_msg:
    "Third party applications who use Nuvio for ticket booking and F&B order modules.",
  recipe_dash_msg:
    "A list of ingredients with required quantity to prepare a dish & sell it.",
  bookingsource_dash_msg:
    "Tickets can be booked online or at POS or at KIOSK or third party apps these are Booking Sources",
  designation_dash_msg:
    "All users designation in Nuvio. Eg: Accounts Manager, Cinema Manager etc.",
  charge_dash_msg:
    "The additions or deductions that is applicable on the ticket amount like Tax, extra fee etc",
  rawmaterial_dash_msg: "List of all raw materials for Food and Beverages.",
  country_dash_msg: "List of all countries in Nuvio",
  city_dash_msg:
    "List of all cities in a particular state/province added to Nuvio",
  crew_dash_msg:
    "A group of people who work on a movie eg: Director, Producer, Actor, Actress etc",
  denomination_dash_msg:
    "The currency denomination available for the currency selected in Nuvio.",
  distributor_dash_msg: "List of all the distributors",
  feature_dash_msg:
    "All CRUD features in a module like add, edit, view, update etc.",
  fb_price_config_dash_msg:
    "Min & Max price is set for each item to be sold in a cinema.",
  fnb_price_dash_msg: "Calculating the selling price for an item in a cinema.",
  food_category_dash_msg:
    "It is a collection of food items that share similar property like Beverage, hot beverage, cold beverage etc",
  movie_category_dash_msg:
    "The movie classified as when it is screened like Now showing, Next change, Coming soon etc",
  gender_dash_msg: "Gender list in Nuvio",
  genre_dash_msg:
    "A style or category of movie. Eg: Drama, Thriller, Romantic etc",
  hardware_dash_msg:
    "Machines and other equipment used in cinema for Tickets and F&B. Eg: POS, KIOSK, Printer etc",
  language_dash_msg:
    "List of all languages in the system used for content or movie",
  marital_dash_msg: "Manage marital status",
  module_dash_msg: "The modules in Nuvio like movie, scheduling, recipe etc",
  format_dash_msg: "Technical definition for a movie. Eg: 2D, 3D etc",
  payment_dash_msg:
    "Different modes to purchase a ticket or pay bill. Eg: Cash, Credit Card, Wallet etc",
  ticket_price_config_dash_msg:
    "Min & Max price is set for seats based on seat type in all screens",
  ticket_dash_msg:
    "The selling price for a ticket derived considering all facts like movie type, show time, show date etc",
  refund_dash_msg: "List of reasons to cancel a ticket",
  production_dash_msg: "List of all production company for movies",
  role_dash_msg:
    "Access roles for users in Nuvio. Role defines which user can access what feature in Nuvio",
  seat_dash_msg:
    "Seat reservations like house seats, Permanent Blocked Seats etc",
  status_dash_msg:
    "The ticket & order status in F&B. Eg: Ticket Booked, Ticket cancelled, F&B Order placed etc",
  shift_dash_msg:
    "Shift is multiple period of time set in a day during which different groups of people perform their duties",
  user_shift_dash_msg: "Shift of the users",
  signage_dash_msg:
    "Signage is a display board to show the information about movie or Food and Beverages in Cinema",
  state_dash_msg: "List of all states/Province in a country",
  unitofmeasurement_dash_msg:
    "Unit of measurement for raw materials. Eg: Kilogram, Litre etc",
  vendor_dash_msg:
    "A company or a person offering raw material for sale to cinema",
  weekday_dash_msg: "All days in a week. Let you set the first day of the week",
  cinemasettings_dash_msg:
    "List of cinema names with operation start time and end time",
  chargetypes_dash_msg:
    "List of tax types for Nuvio. Eg: VAT, Entertainment Tax etc.",
  martialstatus_dash_msg: "Manage marital status",
  refunds_dash_msg:
    "Ticket cancellation or Order Cancellation reasons which leads to refund.",
  managefearture_msg: "Manage all Designation in your",
  cinemauser: "Manage All User",
  cinemasscreens: "Manage all screens",
  delete: "Delete",
  cinemahardware_dash_msg: "Manage all Hardware",
  cinemalist_dash_msg: "Manage cinemas",
  roleaccess_dash_msg: "Manage All your Roles Acces",
  imagesetting_dash_msg:
    "Pre defined image size that will be uploaded in the system",
  org_dash_msg: "Manage the organisations here",
  department_msg: "List of all Departments in Nuvio",
  promotionsandoffer_dashmsg: "Manage all Promotions & Offers",
  home_page_msg: "The Home Page of Nuvio",
  schedule_access_msg: "Access right for schedules",
  fnb_access_msg: "Access rights for fnbs",
  view_schedule_msg: "Manage all the schedules for movies",
  reserveseats_dash_msg: "List of the all the reserved seats",
  floatamount_dash_msg:
    "Initial amount that is with the user when he/she logs in to POS",
  makearefund_dash_msg: "Make refund on the ticket",
  showrefund_dash_msg: "Refund status for the movies",
  concession_dash_msg: "Concessions for the cinemas",
  weekends_dash_msg: "Weekend days for the cinemas",
  hardwaresettings_dash_msg: "List of hardware settings for the devices",
  signageurl_dash_msg: "Signage for the cinemas",
  signagemapping_dash_msg: "List of all the signages",
  releaseseat_dash_msg: "Release seat(s) on the ticket",
  customertransactions_dash_msg: "View the transactions of the customers",
  supportticketing_dash_msg: "List of support tickets",
  fnbauditlogs_dash_msg: "Details about the fnb audits",
  scheduleauditlogs_dash_msg: "Details about the schedule audits",
  systemLogs_dash_msg: "Details about the system audits",
  fnbDynamicPricing_dash_msg: "Details about the pricing of fnb",
  contract_dash_msg: "List of the contracts",
  weekwiseContract_dash_msg: "List of the weekwise contracts",
  distributorContract_dash_msg: "List of the distributor contracts",
  checklistcategories_dash_msg: "Manage All your Checklist Categories",
  imagegallery_dash_msg: "Gallery of the images",
  addons_dash_msg: "Manage all your add-ons",
  banners_dash_msg: "Manage all the banners",
  cinematypes_dash_msg: "Manage all your cinema types",
  tiertypes_dash_msg: "Manage all your tier types",
  region_dash_msg: "List of all the regions",
  currency_conversation_dash_msg: "List of all currencies conversion in Nuvio",
  ticket_type_dash_msg: "Manage ticket types",
  sound_dash_msg: "Manage sound formats",
  clients_dash_msg: "Manage all your clients",
  unitconverter_dash_msg: "A simple unit converter",
  documentverification_dash_msg: "Manage document verification",
  tickettemplates_dash_msg: "Manage the status of the ticket templates",
  receipts_dash_msg: "View all your receipts",
  receiptstemplates_dash_msg: "Manage status of all receipt templates",
  cinematickettemplate_dash_msg: "Manage status of all cinema ticket templates",
  autoemailreport_dash_msg: "Manage all the auto email reports",
  emailtemplate_dash_msg: "Manage all the email templates",
  smstemplate_dash_msg: "Manage all the sms templates",
  supportticket_dash_msg: "Manage all the support ticket categories",
  aspect_ratio_msg: "Manage aspect ratios",
  movie_resolutions_msg: "Manage all the movie resolutions",
  movie_experiences_msg: "Manage all the movie experiences",
  translation_list_msg: "Manage all the translations",
  rawmaterialscategory_dash_msg: "Manage all the raw materials categories",
  rawmaterials_dash_msg: "Manage all the raw materials",
  vendors_dash_msg: "Manage all the vendors",
  puchase_order_dash_msg: "Manage your purchase orders",
  storemanagement_dash_msg: "Manage your store",
  stock_in_dash_msg: "List of all Po inward In Nuvio",
  transfer_stocks_dash_msg: "Manage transfer stocks",
  transfer_stocks_logs_dash_msg: "Manage transfer stock logs",
  stock_take_dash_msg: "List of stock takes in Nuvio",
  stock_take_logs_dash_msg: "Details of stock takes in Nuvio",
  concession_stock_dash_msg: "List of concession stock",
  food_categories_dash_msg: "Manage all the food categories",
  recipes_dash_msg: "Manage all the recipes",
  fnb_customization_dash_msg: "Manage all the fnb customization",
  fnb_items_dash_msg: "Manage all the fnb items",
  fnb_wastage_dash_msg: "Manage all the fnb wastage",
  goods_return_dash_msg: "Manage all the goods return",
  invoice_dash_msg: "Manage all the invoices",
  summary_dash_msg: "View the summary of reports",
  report_builder: "Report Builder Beta",
  performance_report_dash_msg: "View the performance report",
  gcam_report_dash_msg: "View the GCAM report",
  daily_sales_report_dash_msg: "View the daily sales report",
  aggregator_daily_sales_report_dash_msg: "View the aggregator sales report",
  screenwise_dash_msg: "View the screenwise collection report",
  distributor_collection_dash_msg: "View the distributor collection report",
  distributor_detailed_dash_msg: "View detailed distributor report",
  transaction_dash_msg: "View the transactions",
  reservations_dash_msg: "View the Reservations",
  reportbuilder_dash_msg: "View Report Builder",
  reportbuilder: "Report Builder",
  transaction_refund_dash_msg: "View the transactions refund",
  movie_analytics_dash_msg: "View the movie analytics",
  film_wise_collection_report_dash_msg: "View the film wise collection report",
  aggregators_report_dash_msg: "View the aggregators report",
  advancebookingreport_dash_msg: "View the advance booking report",
  FandsBAnalytics_dash_msg: "View the fnb analytics",
  Fnbtransaction_dash_msg: "View the fnb transactions report",
  Fnborders_dash_msg: "View the fnb orders report",
  receipereport_dash_msg: "View the recipes report",
  fastmovingreport_dash_msg: "View the fast moving report",
  concessiondailyReport_dash_msg: "View the daily concessions report",
  cogsReport_dash_msg: "View the COGS report",
  stockwastageReport_dash_msg: "View the stock wastage report",
  currentStockReport_dash_msg: "View the current stock report",
  municipalityReport_dash_msg: "View the municipality report",
  expiryreport_dash_msg: "View the expiry report",
  addonsreport_dash_msg: "View the addons report",
  customizationreport_dash_msg: "View the customization report",
  cashcards_dash_msg: "Manage all the cash cards",

  uomshortform: "Short name of the UOM",

  IpAddressRange_tooltip: "Enter a IP Address Range of cinema.",
  contract_name_tooltip: "Name of the Contract",
  contract_description_tooltip: "Description of Contract",
  contract_value_tooltip: "Contract Value (Ex: 50%)",
  // TOOLTIP  NEW ADDED BY AKASH
  crew_tooltip: "Name of crew eg: Actor, Director",
  genre_tooltip:
    "A particular type or variety that a movie belongs to eg: Thriller, Romantic etc",
  country_tooltip: "Name of the country",
  country_code_tooltip: "Short form for country name",
  country_iso_tooltip:
    "International Organization for Standardization (ISO) defined code for the name of countries",
  city_tooltip: "Name of the city",
  distributor_name_tooltip: "Company Name of the distributor",
  sistercompany_tooltip: "Sister Company name if exists",
  contactno_tooltip: "Contact number of the distributor for communication",
  emailid_tooltip: "Email address of distributor for communication",
  tinnumber_tooltip: "Company registered number",
  taxnumber_tooltip: "Tax registration number of distributor",
  distributor_address:
    "When the raw material reaches a particular quantity the admin has to be alerted of the same so that he can place order the raw material",
  distributor_cityname: "City name of the distributor",
  language_tooltip: "Language for content or movie language.",
  language_iso_tooltip: "Language ISO Code.",
  movie_format_tooltip: "The visual dimension of movie",
  cinemadesignationscontract: "Select a Cinema Name",
  moviedesignationcontract: "Select a Movie Name",
  distributordesignationname: "Select Distributor Name",
  sharetypedesignationname: "Select Share Type",
  cinemadistributiondeduction: "Select Cinema Name",
  distribution_distributionDeduction: "Select Distributor Name",
  label_distributionDeduction: "Enter Deduction Name",
  deductionvalueDistributionDeduction: "Enter Deduction Value",
  selectuser_renunciation: "Select User Name whose Leaving",
  dateofleaving_renunciation: "Select Leaving date of User",
  stockindate_updatestockin: "Date on which stock was Transfered in",
  expirydate_updatestockin: "Date on which the stock will expire",
  movieDistributionDeduction: "Select Movie Name",
  cinemaSignageURL: "Select Cinema Name",
  selectsignage_SignageURL: "Select Signage Eg. Playing Now",
  signageTemplate_signageURL: "Select Signage Template Eg. Box Office",
  cupid_signageURL: "Enter CPU Id",
  generated_signageURL: "Generated URL is here",
  sharelabel_tooltip: "Name a share label",
  percentageof_tooltip: "Select percentage of e.g. Net Amount",
  duration_tooltip: "Select duration",
  dst_share_type_description_tooltip:
    "Enter a message for distributor share type",
  searchmovie_tooltip: "Search Movie",
  aggregator_tooltip: "Name of the aggregator",
  contract_start_date_tooltip:
    "The date on which contract was enabled in Nuvio",
  contract_end_date_tooltip: "The date when the contract will get over",
  apiid_tooltip: "The unique id assigned to aggregator to access Nuvio api",
  authentcation_code_tooltip:
    "The authentication code to provide authentication to access Nuvio api",
  username_tooltip: "The username to access Nuvio api",
  aggregator_password_tooltip: "The password to access Nuvio api",
  recipe_name_tooltip: "Name of the recipe that will be sold at concession",
  recipe_description_tooltip:
    "Description of the recipe that will be sold at concession",
  ingredient_tooltip: "Ingredients/raw materials required to prepare recipe.",
  recipe_quantity_tooltip:
    "Quantity of raw material required to prepare recipe.",
  recipe_uom_tooltip:
    "Unit of measurement of raw material required to prepare recipe.",
  bookingdiscount_noof_tooltip:
    "The source from where the ticket is booked eg: Online, KIOSK etc.",
  bookingdiscount_discount_tooltip:
    "The source from where the ticket is booked eg: Online, KIOSK etc",
  chargetypes_tooltip:
    "Name of the charge type eg: Value Added Tax, Service Tax, Entertainment Tax",
  chargetype_code_tooltip:
    "Short form of Charge Type if any eg: VAT, ST, Entertainment Tax",
  currency_tooltip: "Name of the currency",
  currencycode_tooltip:
    "The three-letter alphabetic ISO currency codes that represent the various currencies used throughout the world",
  currency_country_tooltip: "Country to which the currency belong to",
  isweekof_tooltip: "Title cannot be empty",
  vendorname_tooltip: "Name of the vendor",
  vendorsaddress_tooltip:
    "When the raw material reaches a particular quantity the admin has to be alerted of the same so that he can place order the raw material",
  status_tooltip: "Status name for each stage of booking",
  statuscode_tooltip: "Short form for Status name",
  shiftname_tooltop: "Shift name eg: Morning Shift",
  shift_workinghour_tooltip: "No of working hours in a shift",
  shift_starttime_tooltip: "Start time of the shift",
  shift_endtime_tooltip: "End time of the shift",
  seatreservationtype_tooltip: "Name of different seat types",
  role_tooltip: "Name of the Role",
  productioncompany_tooltip: "Name of the production company of movie",
  paymentmode_tooltip:
    "Mode of payment to buy ticket or order Food & Beverages eg: Cash, Credit Card, Wallet etc",
  hardware_tooltip: "The machines installed for the setup to run a cinema",
  foodcategories_tooltip:
    "Food category name eg: Snacks, Beverages etc. These categories can have sub category also.",
  feature_tooltip:
    "Each module has different features like Add User, Edit User, View User Details etc.",
  backuplocationbrowse_tooltip:
    "Select the folder where you want to store all backups for Nuvio",
  denominationvalue_tooltip: "The value of denomination eg: 100, 200 etc",
  denominationcurreny_tooltip:
    "The currency for which denomination will be saved",
  denominationcountry_tooltip: "Select country name for denominations",
  tpcfromdate_tooltip: "Date from which the price will be applicable",
  tpctodate: "Price will be applicable till 'To Date'",
  hardware_selectname_tooltip: "concession level in cinema",
  hardware_selecthardware_tooltip: "Tooltip",
  hardware_username_tooltip: "Tooltip",
  hardware_password_tooltip: "Tooltip",
  hardware_uniquecode_tooltip: "Tooltip",
  hardware_name_tooltip: "Tooltip",
  hardware_connectionport_tooltip: "Tooltip",
  hardware_authenticationcode_tooltip: "Tooltip",
  hardware_selectkey_tooltip: "Tooltip",
  booking_source_tooltip: "Tooltip",
  bookingusercategory_tooltip:
    "Category of user for whom seat is booked. Eg: Students, Senior Citizen, Armed Force personel etc",
  bookingusercategory: "Booking User Category | Booking User Categories",
  bookingusercategory_dash_msg:
    "The user category for whom the ticket is booked eg: Students, Senior Citizens, Armed Force Personel etc.",
  chargetypecode: "Charge Type Code | Charge Type Code",
  imagesettingname_tooltip: "Name the image setting with briefing",
  rating_dash_msg: "Manage all the ratings here",
  censor: "Censor",
  censorrating: "Censor Ratings",
  rating_tooltip:
    "Rate a movies suitability for certain audiences based on its content Eg: PG 13+, PG 18 etc",
  iscinemalevel: "Cinema Role",
  boxoffice: "Box Office",
  organization: "Organization | Organizations",
  logourl: "Logo URL",
  kiosk_screen_image_url: "Screen Image URL",
  setupdate: "Setup Date",
  launchdate: "Launch Date",
  trial: "Trial Version",
  location: "Location",
  screenname: "Screen Name",
  noofscreens: "No of Screens",
  google_map_embedded_url: "Google Map Embedded Url",
  map_view_url: "Map View Url",
  routes: "Routes/Path",
  noofrows: "No of Rows",
  noofcols: "No of Cols",
  noofseats: "No of Seats",
  seatlayout: "Seat Layout",
  manageBrokenSeat: "Manage Broken Seat",
  broken: "Broken",
  others: "Others",
  repair: "Repair",
  isPermanentBroken: "Permanent Broken",
  seatreservetype: "Seat Reserve Type",
  expected: "Expected",
  ofRepair: "of Repair",
  seattype: "Seat Type",
  seatname: "Seat Name",
  rownumber: "Row Number",
  columnnumber: "Column Number",
  ratecard: "Rate Card",
  inclusivoftax: "Inclusive of Tax?",
  overandabove: "Is over and above",
  sharewithdistributor: "Shareable with Distributor",
  taxable: "Taxable",
  chargevalue: "Charge Value",
  isdeduction: "Deduction",
  booking_source_tooltip: "Ticket booking source eg: POS, KIOSK, Online etc",
  addDistributor_tooltip: "Name of the Distribution company",
  addDistributorsiscomp_tooltip: "Name of sister company if exists",
  addDistributorcontactno_tooltip: "Please enter your mobile number",
  addDistributor_website_tooltip: "Please enter website",
  addDistributorfax_no_tooltip: "Please enter fax number",
  addDistributoremailId_tooltip: "Email address of for communication",
  addDistributorTin_tooltip:
    "UID stands for Umsatzsteuer-Identifikationsnummer (German: Value Added Tax Number; EU)",
  addDistributorTax_tooltip: "Tax information number",
  distributorCountry_tooltip: "The country where distributor is located",
  distributorParent_tooltip: "Name of the Parent Company",
  distributorCity_tooltip: "The city where the distributor is located",
  movieFormatname: "Video formality for movie Eg: 2D, 3D etc",
  soundFormatname: "Sound formality for movie Eg: Dolby Atmos, DTS etc",
  refundReasons_tooltip:
    "Reason why a refund needs to be initiated Eg: show cancelled",
  moviecategory_tooltip:
    "The movie show status, whether it is coming soon or now showing etc.",
  state_tooltip: "Name of the state or province",
  statecode_tooltip:
    "Short form or code ( if exists ) for the state or province",
  unitofmeasurement_tooltip: "Definite magnitude of a quantity eg: kilogram",
  uom_parent_tooltip: "The higher magnitude of a quantity. it is not mandatory",
  uom_description: "Explanation for the unit of measurement",
  movietitle_tooltip: "Name of the movie",
  movieSelectCountry: "The country the movie will be played in",
  movieproductioncompany_tooltip:
    "The company or companies who produced the movie",
  movieselectgenre_tooltip:
    "Motion picture category based on similarities either in the narrative elements or in emotional response eg: comedy documentry",
  movieselectlanguage_tooltip: "The spoken language of the movie",
  movieselectsubtitlelanguage_tooltip: "The language of the movie subtitles",
  movieselectdefaultdistributor_tooltip: "The default distributor of the movie",
  movietrailer_tooltip: "The link for the trailer of the movie",
  movieuti_tooltip:
    "The image to be shown to represent movie size 197X295, max 1mb",
  movieselectdistributor_tooltip:
    "The company which distributes the movie in given area",
  movieselectcountry_tooltip:
    "The country where the distributor is distributing the movie",
  movieselectstates_tooltip:
    "The states where the distributor is distributing the movie",
  moviecity_tooltip: "The city where the distributor is distributing the movie",
  moviefromdate_tooltip: "Distribution start date",
  movietodate_tooltip: "Distribution end date",
  movieselectcountry_tooltip:
    "Country based details select country and enter other details accordingly",
  movieReleaseDate_tooltip:
    "The date of releasing the movie in selected country",
  movieOriginalReleaseDate_tooltip: "The original releasing date of the movie",
  movieRuntime_tooltip: "The total time of the movie in mins",
  movieIntervaltime_tooltip: "The interval time of the movie in mins",
  movieIntermissiontime_tooltip: "The intermission time of the movie in mins",

  movieContentTitle_tooltip: "The movie title is selected language",
  movieDescription_tooltip:
    "The long movie discription for the selected language",
  movieShortDescription_tooltip:
    "The short movie discription for the selected language",
  movieSelectCrew_tooltip:
    "People who are involved on making a movie eg: producer, director",
  movieNameOfThePerson_tooltip: "Name of the crew selected",
  movieOrder_tooltip: "Order in which the crew member should appear",
  cinemaSettingsName_tooltip:
    "Name of the cinema with location name to be precise",
  cinemaSettingsRegistration_tooltip:
    "The government registration number to start a cinema/unit",
  cinemaSettingsLicenseNo_tooltip: "The license number of the cinema/unit",
  cinemaSettingsEmail_tooltip: "Email address for communication",
  cinemaSettingContactNo_tooltip: "The contact number for communication",
  cinemaSettingsAddress_tooltip: "The location of the cinema/unit",
  cinemaSettingsCities_tooltip: "The city where the cinema / unit is located",
  cinemaSettingStates_tooltip:
    "The state or province where the cinema/unit is located",
  cinemaSettingsCountry_tooltip: "The country where the cinema/unit is located",
  cinemaSettingsPincode_tooltip:
    "The zipcode of the location where the cinema / unit is located",
  cinemaSettingsLatitude_tooltip:
    "The geographic co-ordinate that specifies the north-south position of earth",
  cinemaSettingsLongitude_tooltip:
    "The geographic co-ordinate that specifies the east-west position of earth",
  cinemaSettingsNoofScreens_tooltip: "The number of screens in cinema",
  cinemaSettingsOperation_tooltip: "The start time of operation in cinema",
  cinemaconcessionlevel_tooltip: "The Cinema Concession Level.",
  cinemaSettingsCleaningTime_tooltip:
    "The cleaning time in mins for the cinema after each movie",
  cinemaSettingsCutofTime_tooltip:
    "The Time in mins after start of the movie after which booking is not allowed",
  cinemaSettingsAdvertisementTime_tooltip:
    "The extra time before the start of the movie advertisements / Trailer",
  cinemaSettings_mycinema_creation_interval_tooltip:
    "The interval between shows created on mycinema",
  cinemaSettings_ondemand_creation_interval_tooltip:
    "The interval between ondemand shows",
  cinemaSettingsSeatReleaseTime_tooltip:
    "The time in mins before which the reserved seat needs to be released for booking",
  backupSettingCinemaCountry_tooltip: "Select cinema for backup of data",
  backupSettingBackupLocationBrowse_tooltip: "Path for backup storage",
  backupSettingDaily_tooltip: "Daily which time backup to be taken",
  backupSettingWeekly_tooltip:
    "On which day of the week backup should be taken",
  backupSettingFortnight_tooltip:
    "Two dates in a month with 15 days gap when backup to be taken",
  backupSettingMonthly_tooltip: "Any date of the month when backup to be taken",
  backupSettingAuto_tooltip: "Backup to be taken automatically",
  backupSettingBackupToKeep_tooltip:
    "Selected the backup folder to be restored",
  citiesCityName_tooltip: "Name of the city",
  citiesLatitude_tooltip: "Point 11",
  citiesLongitude_tooltip: "Point 12",
  citiesCountry_tooltip: "Name of the country where city belongs to",
  currency_tooltip: "Name of the currency",
  citiesState_tooltip: "Name of the state where state belongs to",
  imageSettingHeight_tooltip: "Height of the image",
  imageSettingWidth_tooltip: "Width of the image",
  imageSettingRatio_tooltip: "Ratio of image",
  organizationName_tooltip: "Name of the organization",
  organizationLogourl_tooltip: "Browse logo url size and dimension",
  kiosk_screen_image_url_tooltip:
    "Browse kiosk screen image size and dimension",
  ticket_image_url_tooltip: "Browse ticket image size and dimension",
  organizationcolor_tooltip: "Accent color of the organization",
  organizationhovercolor_tooltip: "Hover color of the organization",
  organizationfontcolor_tooltip: "Font color of the organization",
  organizationAddress_tooltip: "The address of head office of the organization",
  organizationPincode_tooltip: "Postal code or zipcode of the organization",
  organizationCountry_tooltip: "Country where the organization is located",
  organizationState_tooltip: "Name of the state or province",
  organizationCity_tooltip: "City where the organization is located",
  organizationContactNumber_tooltip: "Contact number for communication",
  organizationSetupDate_tooltip: "Date when the application (Nuvio) was setup",
  organizationLaunchDate_tooltip: "Date when the software was launched",
  signage_type:
    "The display screen where the information of movie schedules is displayed",
  weekdays_tooltip: "All weekdays only set the start day of the week",
  vendorsContactNumber_tooltip: "Contact number of vendor of communication",
  vendorsEmailId_toolip: "The email address for communication",
  vendorsTinNumber: "Tax identification number if exists or GST number",
  vendorsAddress_tooltip: "The address of the vendor",
  vendorsCountry_tooltip: "The country of vendor",
  vendorStates_tooltip: "State / Province of the vendor",
  vendorCity_tooltip: "City where the vendor is located",
  select_start_date: "select start date",
  select_end_date: "select end date",
  cinemas_code: "Enter cinema code",
  cinema_Organization: "Select organization",
  us_start_date: "Start date for a shift",
  us_end_date: "End date for a shift",
  cinemas_code: "Enter cinema code",
  cinema_Organization: "Select organization",
  us_start_date: "Start date for a shift",
  us_end_date: "End date for a shift",
  deptname: "Enter a Department Name",
  gendername: "Enter a Gender",
  maritalname: "Enter Marital Status",

  cinemas_CinemaSettings:
    "Name of cinema or unit. A cinema is a multiplex at a particular location",
  cinema_Location: "Google location of the cinema",
  cinema_Address: "Enter cinema address",
  cinema_Pincode:
    "Postal code or zip code of the location where cinema is located",
  cinema_ContactNumber:
    "Contact number of cinema manager for any communication",
  cinema_EmailId: "Email address for any electronic communication",
  cinema_NoOfScreens: "No. of screens a cinema has",
  cinema_latitude: "Latitude of the cinema location",
  cinema_longitude: "Longitude of the cinema location",
  cinema_Cutoftime:
    "The time in minutes after the start of the show when looking will be closed",
  cinema_license: "The government registered license number for cinema",
  cinema_RegistrationNo:
    "The government registered registration number for cinema",
  cinema_OperationStarttime: "The time when operation start at cinema",
  cinema_OperationEndtime: "The end time when operation start at cinema",
  screen_ScreenName: "Name of the screens in cinema Eg: Screen 1",
  screen_NoOfSeats: "Total no. of seats in a particular screens",
  screen_NoofCols:
    "No of seating columns in a screen to create a grid for seat layout",
  screen_NoofRows:
    "No. of seating rows in a screen. to create a grid for seat layout",
  screen_Cinema:
    "List of cinema. Select a cinema to which the screen belongs to",
  screen_Video_Format:
    "The video format supported by the screen Eg: 2D, 3D, 4D etc.",
  screen_Audio_Format:
    "The audio format supported by the screen Eg: Dolby Atmos etc.",
  screen_size_format: "The Screen Size Format Eg: Flat, Scope, etc.",
  screen_Type: "The type of Screen Eg: Gold etc.",
  seatType_SelectCinemas: "Select Cinema/Unit name to add seat type",
  seatType_SelectScreen: "Select screen to add seat type",
  seatType_SeatsTypes: "Enter seat type name eg: Gold, Silver etc",
  chargeSettings_selectCinema: "Select cinema for charge settings",
  chargeSettings_ChargeSettingsName: "Refrence name for charge setting",
  chargeSettings_ChargeTypes:
    "Different charge types for applicable for ticket",
  chargeSettings_FromDate: "Charges applicable from which date",
  chargeSettings_ToDate: "Charge applicable till which date. Non mandatory",
  chargeSetting_chargeValue: "The value of the change Eg: 8%, $100 etc.",
  rateCard_Cinema: "Select cinema for rate card",
  rateCard_fnb: "Select F&B item for rate card",
  rateCard_ChargeSettingName: "Select reference name for charge settings",
  rateCard_RateCardName: "Name of the rate card",
  rateCard_Amount: "The amount for which charges will be calculated",
  ticketPriceConfiguration_cinemas: "Select cinema to configure ticket price",
  ticketPriceConfiguration_Movie:
    "Select movie for which the ticket price has to be done",
  ticketPriceConfiguration_Screens:
    "Select screen on which movie will be screened",
  ticketPriceConfiguration_FromDate:
    "The ticket price applicable from which date",
  ticketPriceConfiguration_ToDate: "Ticket price applicable till which date",
  user_NameTooltip: "Name of the employee",
  user_MiddleName: "Middle name of the employee",
  user_LastName: "Last name of the employee",
  userpin: "User Pin",
  passwordpin: "Password Pin",
  user_Gender: "Gender of the employee",
  user_EmployementType: "The employement type of the user",
  user_DateOfBirth: "Date of birth of the employee",
  user_DateOfJoining: "Date of joining",
  user_Address: "Residential address of the employee",
  user_Country: "Country where employee resides",
  user_State: "State where the employee is from",
  user_Cities: "City of employee residence",
  user_ZipCode: "ZipCode / Postal code or PIN code of the location",
  user_EmailId: "Email address of employee for communication",
  user_phone: "Contact no. of employee",
  user_mobile: "Contact no. of employee",
  user_Username: "Username to login to the system",
  user_Password: "Password for login to the system",
  user_Roles: "Access role for employee in Nuvio",
  user_Designation: "Designation of employee",
  user_Cinema: "Cinema to which employee belongs to",
  user_Employee: "Unique employee code of employee id in organization",
  user_Department: "Users department eg.Accounts,Management etc.",
  floatAmount_User:
    "Select the employee or POS user to whom float amount is given",
  floatAmount_Shift:
    "Select the shift of the employee for the current float amount",
  floatAmount_PosOperation: "Select the POS machine assigned to the employee",
  floatAmount_Amount:
    "Enter the total amount given to the employee as float amount",
  refund_Cinema: "Select the cinema name",
  refund_Screens: "Select Screens",
  refund_Movie: "Select movie",
  refund_showTime: "Select show time",
  refund_RefundReason: "Refund reason which refund is to be done",
  hardwareSettings_SelectCinema: "Select the cinema where hardware is setup",
  hardwareIsDisabled: "Hardware Is Disabled",
  hardwareSettings_Username: "Username for the system if any",
  hardwareSettings_Password: "Password for the system if any",
  hardwareSettings_SelectedHardwareType: "Select the type of hardware",
  hardwareSettings_HardwareUniqueCode:
    "Enter the unique code / Mac address / CPU ID of hardware",
  hardwareSettings_HardwareName: "Name of the hardware",
  hardwareSettings_ConnectionPort: "Connection port of the hardware",
  hardwareSettings_installBy: "Who installed the hardware",
  rawmaterial_tooltip: "The basic material from which F&B recipes are made",
  rawmaterial_Code: "Unique Code",
  quantityalert_tooltip:
    "The threshold limit at which the system will notify manager to order raw material",
  description_tooltip: "Briefing the raw material",
  rawMaterial_unitofmeasurement:
    "Definite magnitude of a quantity defined & adopted by convention",
  vendor_TinNumber: "Tax information number of vendor",
  vendor_TaxNumber: "Tax number or PAN number of vendor",
  vendor_TaxType: "Type of tax",
  vendor_address: "Address of vendor",
  vendor_location: "Google map location of vendor",
  vendorMapping_selectCinema:
    "Cinema name to link vendor who supplies raw material",
  vendorMapping_selectVendor: "Name of the vendor who supplies raw material",
  vendorMapping_selectRawMaterial:
    "Raw material supplied by the selected vendor",
  vendorMapping_Quantity: "Quantity of raw material to set the cost",
  vendorMapping_SelectUnitOfMeasurement:
    "UOM for quantity selected to set cost",
  vendorMapping_rate: "Cost at which raw material will be supplied",
  includesegg: "Includes Egg",
  cinemaCurrency_tooltip: "Currency used for transactions in cinema",
  cinemaCountry_tooltip: "The Country where cinema is located",
  cinemaState_tooltip: "State where the cinema is located",
  cinemaCity_tooltip: "City where the cinema is located",
  seatTypeSeatno_tooltip: "Total number of seats in cinema",
  movieselectcinema_tooltip:
    "Select cinema where distributor is having share for the movie",
  purchaseOrder_selectCinema: "Select cinema for which PO is created",
  purchaseOrder_selectVendor:
    "Select the vendor who will provide raw materials",
  purchaseOrder_RawMaterials:
    "The raw materials used in cinema for concession or office",
  purchaseOrder_Quantity: "The amount of raw material required",
  purchaseOrder_selectUOM: "The unit of measurement for raw material",
  purchaseOrder_TotalAmount: "Gross amount with Tax",
  purchaseOrder_PurchaseOrderDate: "Date of purchase order",
  recipe_code_tooltip: "Unique code for recipe",
  fnbitems_tooltip: "Name of the recipe",
  fnbitems_itemCode_tooltip: "Unique code for an item",
  fnbitems_foodcategory_tooltip: "The category to which the item belongs to",
  foodorder_tooltip: "The order in which categories will appear in Pos",
  select_week_tooltip: "Week for share value",
  select_contract_tooltip: "Share Value of particular week",
  itemcostprice_fnb: "Select a F&B item",
  itemcostprice_costPrice: "Cost price for the item",
  ratecard_cinema: "Select cinema to which the rate card os linked",
  ratecard_chargesettingname: "Name of the charge setting",
  ratecard_ratecardname: "Name the rate card to identify early",
  ratecard_Amount: "Price for a seat",
  fnbpricing_Cinemaname: "Select cinema to add F&B price",
  fnbpricing_Fnbitem: "The F&B item to be sold",
  fnbpricing_ratecard: "The rate card defines the amount for the F&B item",
  fnbpricing_netAmount: "Net amount for the item",
  fnbpricing_totalamount: "Gross amount for the item",
  fnbpricing_fromdate: "The date from which the amount in valid",
  fnbpricing_todate: "The data to which the amount is valid",
  fnbwastage_selectcinema: "Select cinema to recard wastage",
  fnbwastage_selectconcession: "Select store level",
  fnbWastage_store_tooltip: "Select Store Level",
  fnbwastage_rawmaterials: "Select the raw materials",
  remark: "Remark",
  fnbwastage_selectunitofmeasurements: "Select unit of measurements",
  fnbwastage_selectquantity: "Select quantity",
  fnbwastage_selectrate: "Select Rate per Item",
  fnbwastage_accountableuser: "Wastage done by the user",
  fnbwastage_approvedby: "The manager who needs to approved",
  fnbwastage_reasons: "Reason why the wastage happend",
  fnbwastage_fireamount: "The amount that needs to be paid by the user",
  fnbwastage_fromdate: "Date of wastage recorded",
  hr_display_time: "Hours Display Time",
  purchaseOrder_NetAmount: "Net amount without tax",
  taxtypeDistributor: "Provide tax type of Distributor",
  addressDistributor: "Provide Address of Distributor",
  enterbankname: "Enter bank name",
  selecktbankbinbumbers: "Select Bank Name",
  bankname: "Bank Name",
  uploadsheetbinnumbers: "Upload Excel Sheet/CSV with Bin Number",
  offernameoffertype: "Enter Offer Name",
  marketingtypeoffertype: "Select Marketing Type",
  customerName: "Enter Customer Name",
  customerEmail: "Enter Customer Address",
  customerMobile: "Enter Contact No.  of Customer",
  customerDoj: "Enter Joining Date of Customer",
  customerDob: "Select Birth Date of Customer",
  customeranniversarydate: "Select Anniversary Date of the Customer",
  customerInstitution: "Select Institution Name",
  customerusercategory: "Select User  Category Eg. Armed",
  customerAddress: "Enter Residential Address of the Customer",
  customerCountry: "Select Country where customer resides",
  customerSelectState: "Select State from where the customer is from",
  customerSelectCity: "Select City where customer resides",
  institutionName: "Enter Institution Name",
  institutionCinema: "Select a Cinema Name",
  movieselectsound_tooltip: "Sound format required for movie",
  cinema_type_name: "Enter Cinema type name",
  tier_type_name: "Enter tire type name",
  // MENU

  exhibitor_management: "Exhibitor Management",
  user_management: "User Management",
  department: "Department",
  seatType: "Seat Type",
  seatLayout: "Seat Layout",
  chargesettings: "Charge Settings",
  floatAmount: "Float Amount",
  hardwareSettings: "Hardware Device Settings",
  macsSettings: "MACCS Settings",
  macsLogs: "MACCS Logs",
  macsId: "MACCS ID",
  macsMovieStatus: "MACCS Movie Status",
  shareType: "Share Type",
  cinemaMasters: "Cinema Masters",
  vendorMapping: "Vendor Mapping",
  purchaseOrder: "Purchase Order",
  foodCategories: "Food Categories",
  fbItems: "F&B items",
  store: "Store",
  stock: "Stock",
  concessionStock: "Concession Stock",
  rateCard: "Rate Card",
  fbPricing: "F&B Pricing",
  wastemanagement: "Wastage Management",
  roleAccess: "Role Access",
  foodNbev: "Food & Beverages",
  advancebookingreport: "Advance Booking Report",
  weekwiseContract: "Week Wise Contract",

  //Promotion And Offers
  applicableontransactiontime: "Can Avail Offer On Advanced Booking",

  //store
  storeManagement: "Store Management",
  storemanagement: "Store Management",
  sm_store_name: "Store Name",
  sm_store_slug: "Store Slug",
  sm_order: "Order",
  sm_store_name_tooltip: "Store Name to be visible in system",
  sm_store_slug_tooltip:
    "Identifier for a particular Store used for technical settings",
  sm_order_tooltip: "The order in which multiple store level will be displayed",

  //Support Ticket Category
  category_name: "Enter a ticket category name.",

  //Support Ticket
  supportticket_cinema: "Select cinema for support ticket.",
  supportticket_user: "Select user for support ticket.",
  supportticket_category: "Select category for support ticket.",

  //Checklist categories
  checklist: "Checklist",
  checklist_category_name: "The Name of the Checklist Category.",
  checklist_category_description: "Description for the Checklist Category",

  //Checklist
  checklist_name: "The Name of the Checklist.",
  checklist_category: "Select Checklist Category.",
  checklist_cinema: "Select Cinema.",

  //Sound Formats
  soundformats: "Sound Formats",
  soundformat: "Sound Format",
  sound: "Sound",

  //clients
  client: "Client",
  clients: "Clients",
  client_name: "Client Name",
  client_description: "Client Description",
  client_contact_person_name: "Client Contact Person Name",
  client_contact_person_email_id: "Client Contact Email Address",
  client_contact_person_mobile_number: "Client Contact Number",
  client_address: "Client Address",

  //fnbDynamicPricing
  fnbDynamicPricing: "FnB Dynamic Pricing",
  fdpName: "Pricing Name",
  fdpDescription: "Pricing Description",
  day: "Day",
  fromDateTime: "From Date Time",
  toDateTime: "To Date Time",
  oldItemPrice: "Old Item Net Price",
  newItemPrice: "New Item Net Price",
  selling: "Selling",
  difference: "Difference",
  not: "Not",
  //add-ons
  addons: "Add-ons",
  addonItemName: "Add-on Item Name",
  addonItemDescription: "Add-on Item Description",
  itemdes: "Item Description",
  maxQty: "Maximum Quantity",
  itemPrice: "Item Price",
  isTaxApplicable: "Is Tax Applicable?",
  isSundry: "Sundry/Misc/Other Item?",
  //customization
  customization: "Customization",
  customizationName: "Customization Name",
  customizationDescription: "Customization Description",
  isChargeAble: "Is Chargeable",
  compulosry: "Compulsory?",
  cinema_imageurl: "Image for Cinema",
  //currency conversion
  currency_conversion_rate: "Conversion Rate",
  currency_conversion_dash_msg: "List of all currencies conversion in Nuvio",
  currency_conversion: "Currency Conversion | Currencies Conversion",
  effective_date: "Effective Date",
  conversion_rate: "Conversion Rate",

  changePassword: "Change Password",

  //ToolTip

  //Error Messages
  effectivedate_errormsg: "The effective date must be in the format mm/dd/yyyy",
  conversionrate_errormsg:
    "The conversion rate must be numeric and may contain decimal points",
  timezone: "Please select time zone",
  addMultiSchedule: "Add Multiple Schedule",

  ttTooltip: "Please enter ticket type",
  tterror: "The Ticket Type is required",
  Movie_sceneimage: "Movie Scene Image",
  Movie_Banner_Moviedetail_web: "Movie Banner Movie Details Web",

  item_code: "Item Code",
  Boxoffice: "Boxoffice",
  FnB: "FnB",
  BOTransactions: "Box Office Transactions",
  FBTransactions: "FnB Transactions",
  IsSuperCategory: "Is Super Category",
  categorylinkmovies: "MyFestival Movie",
  pleaseSelectMovie: "Please Select Movie",
  selectFromDate: "Please Select From Date",
  selectToDate: "Please Select To Date",
  category_link_name: "Enter Event Name",
  category_link_description: "Enter Category Description",
  link_url: "Enter Category Link Url",
  selectImg: "Please Select Image",
  imgSize: "Dimensions of Image",

  //New
  messageSUISAID: "Please enter movie unique id.",
  endDateIfStartDateError: "End date is required if start date is provided",
  screentype: "Screen Type | Screen Types",
  screensizeformat: "Screen Size Format | Screen Size Formats",
  tmsid: "TMS ID | tms id",
  movie_unique_tooltip: "Eg. SUISA",
  signage_tooltip: "Eg: Coming Soon, Now Showing etc",
  signage_type_tooltip: "Eg: Generic, Movie etc",
  isocode2_tooltip: "Eg: en, fr etc",
  isocode3_tooltip: "Eg: eng, fra etc",
  comment_name_error: "Please Select Comment",
  country_iso3_requires: "Please Enter ISO 3 Code",
  country_iso2_requires: "Please Enter ISO 2 Code",
  screen_imageurl: "Please upload Screen Image",
  addbinNumber: "Please add Bin Number",
  addcardtype: "Please add card type",
  cardtype: "Card Type",
  organizationCinema_tooltip:
    "Maximum number of cinemas allowed in this organization",
  client_name_tooltip: "Enter Client Name",
  client_description_tooltip: "Enter Client Description",
  client_contact_person_name_tooltip: "Enter Client Contact Person Name",
  client_contact_person_email_id_tooltip: "Enter Client Email Address",
  client_contact_person_mobile_number_tooltip: "Enter Contact Number",
  client_address_tooltip: "Enter Client Address",
  template_name: "Enter Template Name",
  select_receipt_template: "Please Select Receipt Template",
  select_user: "Select User",
  select_report: "Select Report",
  select_cinema_report: "Select Cinema for Auto Email Report",
  cinema_email_report: "Cinema for Auto Email Report",
  campaign: "Compaign",
  FormatOrder_tooltip: "Order in which the format will appear in the list",
  Rating_order: "Order in which the rating will appear in the list",
  MoviePlot: "Movie Plot",
  Images: "Images",
  image_setting_desciption: "Description of Image",
  tms: "DCP CPL / TMS ID",
  activity: "Activity",
  logs: "Logs",
  fnbitems_itemdescription_tooltip: "Description of the Item",
  optional: "Optional",
  final: "Final",
  entry_id: "Entry Id",
  entry_id_tooltip: "Enter Your Entry Id",
  entry_description: "Entry Description",
  entry_description_tooltip: "Enter Your Entry Description",
  noofminseats: "Min No of Seats",
  unique_screen_id: "Unique ID For The Screen",
  select_screens: "Select Screen",
  select_mycinema_screens: "Screens Active for MyCinema Shows :",
  select_ondemand_screens: "Screens Active for On Demand Shows :",
  selectratecard: "Please Select Rate Card Group",
  selectprivateratecard: "Please Select Rate Card Group Beta",
  comments: "Schedule Comments",
  comments_dash_msg: "List of all Schedule Comments",
  comment: "Schedule Comment",
  comment_description: "Schedule Comment Description",
  comment_name: "Schedule Comment Name",
  "aspect-ratio": "Aspect Ratio",
  "movie-resolution": "Movie Resolution",
  "movie-experience": "Movie Experience",
  banner_name: "Banner Name",
  banner_description: "Banner Description",
  Phone_Number: "Phone Number",
  device: "device",
  Refresh: "Refresh",
  tax_name: "Tax Name",
  tax_value: "Tax Value",
  is_per_ticket: "Per Ticket",
  person: "Person",
  taxes: "Taxes",
  tax_name_required: "Please enter tax name",
  tax_value_required: "Please enter tax value",
  order_required: "Order is Required",
  start_day: "Start Day",
  label_1: "Visible at the Bottom of ticket",
  label_2: "Visible at the Bottom of ticket",
  email_temp: "Please Select Template for an Email",
  sms_temp: "Please Select Template for SMS",
  whatsapp_temp: "Please Select Template for WhatsApp",
  ticket_temp: "Please Select Ticket Template",
  select_cinemas: "Please Select Cinemas",
  numCopies: "Please Enter No. of Copies",
  preview: "Preview",
  banner_type: "Banner Type",
  age_limit_required: "Please Enter Age Limit",
  age_limit_tooltip: "eg: 16, Person with age 16 or Above are allowed",
  entry_before_show_start_required:
    "Please Enter time for entry allowed before show starts",

  entry_after_show_start_required:
    "Please Enter time for entry allowed after show starts",
  entry_before_show_start: "Entry Allowed Before Show Starts",

  before_show_start: "Before Show Starts",

  entry_after_show_start: "Entry Allowed After Show Starts",
  after_show_start: "After Show Starts",
  batch: "Batch",

  entry_before_show_start_tooltip:
    "The Time in mins from which the entries are allowed before show starts",
  entry_after_show_start_tooltip:
    "The Time in mins till which the entries are allowed after show starts",
  button_text: "Button Text",
  button_text_tooltip:
    "Button Text will be appear on the banner button Eg: Book Now",
  fade: "Fade",
  voucher_start_time:
    "specific time from which the usage of voucher will start. Default Value will be Current Time",
  voucher_end_time:
    "specific time after which the usage of voucher will be expire.",
  offer_start_time: "Time from which the offer usage will be start",
  offer_end_time: "Time at which offer will be End",
  o_end_show_time: "Offer Applicable on Movies till time",
  o_start_show_time: "Offer Applicable on Movies From time",
  manage_translation: "Manage All Your Translations From Here",
  translations: "Translation",
  pages: "Pages",
  rc_start_time_required: "Please Enter Start Time",
  rc_end_time_required: "Please Enter End Time",
  refunded_by: "Refunded By",
  please_enter_all_details: "Please Enter All Details",
  Wait_till_show_date: "Wait till show date and time",
  min_unit: "in smallest unit",
  swap: "Swap",
  swapped: "Swapped",
  swapsource: "Swap Source",
  voucher_start_date_tooltip: "Voucher Applicable from transaction date",
  voucher_end_date_tooltip: "Voucher Applicable till transaction date",
  offer_start_date_tooltip: "Offer Applicable from transaction date",
  offer_end_date_tooltip: "Offer Applicable till transaction date",
  offer_applicable_between_time: "Offer Applicable on Movies Between Show Time",
  swap_dash_msg: "List of All Swapped Transactions",
  title_required: "Title Required",
  cms_title: "Header",
  desc_required: "Description Required",
  cms_desc: "Description",
  cms_btn_text: "Button Text",
  cms_btn_tooltip: "Text to be shown on CMS button",
  cms_btn_required: "Please Enter Button Text",
  CMS: "CMS",
  cms_btn_url: "Button Url",
  cms_btn_url_tooltip: "On Click Button The Page Redirects to this URL",
  clear: "Clear",
  amount_2: "Amount",
  offer_content_desc: "Promotion and Offer Description",
  offer_content_title: "Offer And Promotion title",
  available_sound_formats: "Available Sound Formats in Cinema",
  label_top_1: "Visible below transaction id.",
  movie_label: "Movie Label | Movie Labels",
  fnb_label: "Fnb Label | Fnb Labels",
  movie_label_tooltip: "Movie Labels. Eg: 'Retro'",
  fnb_label_tooltip: "FnB Labels. Eg: 'Small'",
  label_dash_msg: "List of all Movie Labels",
  label_fnb_dash_msg: "List of all FnB Labels",
  label: "Movie Label",
  labels: "Movie Labels",
  labels_fnb: "FnB Labels",
  shortcode: "Short Name",
  remaining_balance: "Remaining Balance",
  //24 August 2021 Dharmesh
  movieName: "Movie Name",
  boxoffice_amount: "BoxOffice Amount",
  fnb_amount: "Fnb Amount",
  shiftLogs: "Shift Logs ",
  noNotificationlogsFound: "No Notification Logs Found",
  collectionAmount: "Collection Amount",
  differenceAmount: "Difference Amount",
  systemAmount: "System Amount",
  status: "Status",
  action: "Action",
  shiftLogindate: "Shift Login Date",
  loginTime: "Login Time",
  logouttime: "Logout Time",
  noRecordsfound: "No records found",
  //25 August 2021 Dharmesh
  users: "Users",
  //26 August 2021 dharmesh
  checklists: "Checklists",
  manageAllyourchecklistshere: "Manage All your Checklists here.",
  checklistName: "Checklist Name",
  checklistItem: "Checklist Item",
  movieID: "Movie ID",
  salesChannelForSchedule: "Sales Channel For Schedule",
  salesChannelForFoodAndBeverages: "Sales Channel For Food and Beverages",
  feedbackForms: "Feedback Forms",
  scheduleList: "Schedule List",
  cinemaSettings: "Cinema Settings",
  //27 August 2021 dharmesh
  shifts: "Shifts",
  ticketPricing: "Ticket Pricing",
  rateCardgroup: "Rate Card Group",
  privateRateCardGroup: "Rate Card Group Beta",
  customerTransactions: "Customer Transactions",
  myCinemas: "My Cinemas",
  myFestivalMovies: "Movie Category",
  myCinemaCinemaSchedule: "MyCinema Cinema Schedule",
  cinemaScheduleList: "Cinema Schedule List",
  movieLicence: "Movie Licence",
  myCinemaDailySalesReport: "MyCinema Daily Sales Report",
  myCinemaTransactionReport: "MyCinema Transaction Report",
  marketingAutomations: "Marketing Automations",
  userJourney: "User Journey",
  segments: "Segments",
  cashCards: "Cash Cards",
  cmsPages: "CMS Pages",
  globalloyaltysettings: "Global Loyalty Settings",
  cinemaloyaltysettings: "Cinema Loyalty Settings",
  occupanyReport: "Occupany Report",
  dailySalesReport: "Daily Sales Reports",
  cinemaReport: "Cinema Report",
  transactionRefund: "Transaction Refund",
  swapTransactions: "Swap Transactions",
  movieReports: "Movie Reports",
  fandbReports: "F&B Reports",
  fandbAnalytics: "F&B Analytics",
  Fnborders: "F&B App Orders",
  checklistCategories: "Checklist Categories",
  imageGallery: "Image Gallery",
  banner: "Web Banner | Web Banners",
  ticketType: "Ticket Type",
  aspectRatio: "Aspect-ratio",
  movieResolution: "Movie-Resolution",
  movieExperience: "Movie Experience",
  listOfAddSeatTypes: "List of add Seat Types",
  basic: "Basic",
  information: "Information",
  info: "Information to be printed on reciept",
  screeningType: "Screening",
  movieUniqueID: "Unique ID",
  default: "Default",
  selectTheRegion: "Select the region",
  enterScreenSizeFormat: "Please Enter Screen Size Format",
  enterScreenTypeName: "Enter Screen Type Name",
  pleaseEnterScreenTypeName: "Please Enter Screen Type Name",
  pleaseEnterScreenSizeFormatName: "Please Enter Screen Size Format Name",
  amount_updated_by: "Amount updated by user",
  selectCinema: "Select Cinema",
  pleaseSelectChargeType: "Please Select Charge Type.",
  noRecordsFoundPleaseSelectCinema: "No Records Found. Please select Cinema",
  pleaseSelectCinema: "Please Select Cinema.",
  pleaseSelectChargeSettingName: "Please Select Charge Setting Name.",
  internetHandlingFees: "Internet Handling Fees",
  online_fee: "Online Booking Fee",
  isPercentageofGross: "Is Percentage of Gross",
  reportsOnlyFeeLabel: "Reports Only Fee Label",
  reportsOnlyFeeValue: "Reports Only Fee Value",
  rateCardGroupTitle: "Rate Card Group Title",
  nameOfRateCardgroup: "Name of Rate Card group",
  searchCinema: "Search Cinema",
  selectVersion: "Select Version",
  concessionSaleAnalysis: "Concession Sale Analysis",
  units: "Units",
  qty: "Qty",
  suboutlet: "Suboutlet",
  internetHandling: "Internet Handling",
  showFromDate: "Show From Date",
  showToDate: "Show To Date",
  filter: "Filter",
  typeToSearchUser: "Type to search user",
  showBookingCode: "Show Booking Code",
  bookingUser: "Booking User",
  amounts: "Amount",
  mobileNo: "Mobile No",
  booked: "Booked",
  month: "Month",
  selectMovies: "Select Movie",
  internetFee: "Internet Fee",
  aggregatorName: "Aggregator Name",
  delivery: "Delivery",
  std: "Std",
  amount_updated_by: "Amount updated by user",

  movieName: "Movie Name",
  boxoffice_amount: "BoxOffice Amount",
  fnb_amount: "Fnb Amount",
  shiftLogs: "Shift Logs ",
  noNotificationlogsFound: "No Notification Logs Found",
  collectionAmount: "Collection Amount",
  differenceAmount: "Difference Amount",
  systemAmount: "System Amount",
  status: "Status",
  action: "Action",
  shiftLogindate: "Shift Login Date",
  loginTime: "Login Time",
  logouttime: "Logout Time",
  noRecordsfound: "No records found",
  //25 August 2021 Dharmesh
  users: "Users",
  //26 August 2021 dharmesh
  checklists: "Checklists",
  manageAllyourchecklistshere: "Manage All your Checklists here.",
  checklistName: "Checklist Name",
  checklistItem: "Checklist Item",
  movieID: "Movie ID",
  salesChannelForSchedule: "Sales Channel For Schedule",
  salesChannelForFoodAndBeverages: "Sales Channel For Food and Beverages",
  feedbackForms: "Feedback Forms",
  scheduleList: "Schedule List",
  cinemaSettings: "Cinema Settings",
  //27 August 2021 dharmesh
  shifts: "Shifts",
  ticketPricing: "Ticket Pricing",
  rateCardgroup: "Rate Card Group",
  privateRateCardGroup: "Rate Card",
  customerTransactions: "Customer Transactions",
  myCinemas: "My Cinemas",
  myFestivalMovies: "Movies Category",
  myCinemaCinemaSchedule: "MyCinema Cinema Schedule",
  cinemaScheduleList: "Cinema Schedule List",
  movieLicence: "Movie License",
  myCinemaDailySalesReport: "MyCinema Daily Sales Report",
  myCinemaTransactionReport: "MyCinema Transaction Report",
  marketingAutomations: "Marketing Automations",
  userJourney: "User Journey",
  segments: "Segments",
  cashCards: "Cash Cards",
  cmsPages: "CMS Pages",
  globalloyaltysettings: "Global Loyalty Settings",
  cinemaloyaltysettings: "Cinema Loyalty Settings",
  occupanyReport: "Occupany Report",
  dailySalesReport: "Daily Sales Reports",
  cinemaReport: "Cinema Report",
  transactionRefund: "Transaction Refund",
  swapTransactions: "Swap Transactions",
  movieReports: "Movie Reports",
  fandbReports: "F&B Reports",
  fandbAnalytics: "F&B Analytics",
  Fnborders: "F&B App Orders",
  checklistCategories: "Checklist Categories",
  imageGallery: "Image Gallery",
  banner: "Web Banner | Web Banners",
  ticketType: "Ticket Type",
  aspectRatio: "Aspect-ratio",
  movieResolution: "Movie-Resolution",
  movieExperience: "Movie Experience",
  listOfAddSeatTypes: "List of add Seat Types",
  basic: "Basic",
  information: "Information",
  screeningType: "Screening",
  movieUniqueID: "Movie Unique ID",
  default: "Default",
  selectTheRegion: "Select the region",
  enterScreenSizeFormat: "Please Enter Screen Size Format",
  enterScreenTypeName: "Enter Screen Type Name",
  pleaseEnterScreenTypeName: "Please Enter Screen Type Name",
  pleaseEnterScreenSizeFormatName: "Please Enter Screen Size Format Name",
  amount_updated_by: "Amount updated by user",
  selectCinema: "Select Cinema",
  pleaseSelectChargeType: "Please Select Charge Type.",
  noRecordsFoundPleaseSelectCinema: "No Records Found. Please select Cinema",
  pleaseSelectCinema: "Please Select Cinema.",
  pleaseSelectChargeSettingName: "Please Select Charge Setting Name.",
  internetHandlingFees: "Internet Handling Fees",
  isPercentageofGross: "Is Percentage of Gross",
  reportsOnlyFeeLabel: "Reports Only Fee Label",
  reportsOnlyFeeValue: "Reports Only Fee Value",
  rateCardGroupTitle: "Rate Card Group Title",
  nameOfRateCardgroup: "Name of Rate Card group",
  searchCinema: "Search Cinema",
  selectVersion: "Select Version",
  concessionSaleAnalysis: "Concession Sale Analysis",
  units: "Units",
  qty: "Qty",
  suboutlet: "Suboutlet",
  internetHandling: "Internet Handling",
  showFromDate: "Show From Date",
  showToDate: "Show To Date",
  filter: "Filter",
  typeToSearchUser: "Type to search user",
  showBookingCode: "Show Booking Code",
  bookingUser: "Booking User",
  amounts: "Amount",
  mobileNo: "Mobile No",
  booked: "Booked",
  month: "Month",
  selectMovies: "Select Movies",
  internetFee: "Internet Fee",
  aggregatorName: "Aggregator Name",
  delivery: "Delivery",
  std: "Std",
  amount_updated_by: "Amount updated by user",

  timeZoneTitle: "Time Zone",

  intermissionTimeError__numeric: "Intermission Time must be numeric",
  intermissionTimeError__required: "Please Enter Intermission Time",
  cleaningTimeError__numeric: "Cleaning Time must be numeric",
  cleaningTimeError__required: "Please Enter Cleaning Time",
  advertisementTimeError__numeric: "Advertisement Time must be numeric",
  advertisementTimeError__required: "Please Enter Advertisement Time",
  searchRawMaterial: "Search Raw Material",
  returns: "Returns",
  tranferInFromUnit: "Tranfer In From Unit",
  transferOutUnit: "Transfer Out Unit",
  openingStock: "Opening Stock",
  consumption: "Consumption",
  wastage: "Wastage",
  dailyConcessionReport: "Daily Concession Report",
  dailySalesConcessionReport: "Daily Sales Concession Transaction Report",
  campaigns: "Campaigns",
  manageAllYouMarketingEmailCampaigns:
    "Manage All you marketing email campaigns",
  completion: "Completion",
  campaign: "Campaign",
  message: "Message",
  test: "Prueba",
  launch: "Launch",
  super: "Super",
  logoShouldBeOfDimensionPngJpgJpegSvg:
    "Logo should be of dimension 300x300 pixels, not more than 2mb of size & supported file types are png, jpg, jpeg, svg",
  category_description: "Category Description",
  event: "Event",
  pleaseSelectCategory: "Please Select Category",
  selectCategory: "Select Category:",
  imageSize: "Image Size",
  link: "Link",
  translate: "Translate",
  editSchedule: "Edit Schedule",
  cinemas: "Cinemas",
  minSeats: "Min Seats",
  privateScreeningCharge: "Private Screening Charge",
  searchRateCard: "Search Rate Card",
  range: "Range",
  intervalMin: "Interval Min",
  searchType: "Search Type",
  licence: "Licence",
  selectuser: "Select User",
  searchFilters: "Search Filters",
  seats: "Seats",
  amounts: "Amount",
  manageAllyourCashCardshere: "Manage All your Cash Cards here.",
  searchs: "Search...",
  credit: "Credit",
  debit: "Debit",
  credited: "Credited/Debited By",
  closing: "Closing",
  bookingCode: "Booking Code",
  orderCode: "Order Code",
  lists: "List",
  pleaseEnterCardNumber: "Please Enter Card Number",
  pleaseSelectCustomer: "Please Select Customer",
  creditedby: "Credited by",
  selectBank: "Select Bank",
  pleaseSelectBankName: "Please select bank name",
  enterCardType: "Enter card type",
  pleaseEnterCardType: "Please Enter Card Type",
  selectCinemas: "Cinemas",
  selectSeatClass: "Select Seat Class",
  selectTicketType: "Select Ticket Type",
  pleaseSelectAtLeastOneday: "Please select at least one day.",
  selectClient: "Select Client",
  minimumTicketAmount: "Min Ticket Amount",
  minTicketAmount: "Min ticket amount",
  ticket_fnbitem: "tickets/fnb items & get discount of",
  tickets: "Tickets",
  SelectFBItem: "Select F&B Item",
  selectInstitute: "Select Institute",
  pleaseSelectInstitution: "Please select institution.",
  selectVerificationid: "Verification Id",
  please: "Please",
  selectCardType: "Select Card Type",
  redemptionCount: "Redemption Count",
  maxRedemptionPerUser: "Max Redemption Per User",
  offerApplicableOnGrossAmount: "Offer applicable on gross amount",
  offerApplicableOnNetAmount: "Offer applicable on net amount",
  applicableOn: "Applicable On",
  offerValidOnDays: "Offer Valid On Days",
  redeemAtOnline: "Redeem At Online",
  redeemAtBoxoffice: "Redeem At Boxoffice",
  redeemAtConcession: "Redeem At Concession",
  movies: "Movies",
  screens: "Screens",
  validFor: "Valid For",
  manageAllVouchers: "Manage all vouchers",
  selectAllCinemas: "Select All Cinemas",
  minBill_Redemption: "Min Bill / Ticket amt for redemption",
  maximum: "Maximum",
  voucherRedemptionperPatron: "Redemption Per Patron",
  voucherRedeemOnNetAmount: "Voucher redeem on net amount",
  voucherRedeemOnGrossAmount: "Voucher redeem on gross amount",
  redemption: "redemption",
  voucherRedemptionPercentageAtFNB: "Redemption Percentage At FNB",
  redeemAt: "Redeem At",
  online: "Online",
  Please_select_client: "Please select client",
  selectPartner: "Select Partner",
  configurations: "Configuration",
  redeemON: "Redeem ON",
  redeem: "Redeem",
  maxBillRedemption: "Max Bill/ticket amount for redemption",
  max: "Max",
  manageAllGlobalLoyalty: "Manage all Global Loyalty",
  inactive: "Inactive",
  manage: "Manage",
  enterBankName: "Enter Bank Name",
  enterBankAddress: "Enter Bank address",
  selectTheBankResides: "Select country in which the bank resides",
  select_TheBankResides: "Select state in which the bank resides",
  selectCityTheBankResides: "Select city in which the bank resides",
  LogoShouldbeOfDimension:
    "Logo should be of dimension 300x300 pixels, not more than 2mb of size & supported file types are png, jpg, jpeg, svg",
  pleaseSelectBinNumberFile: "Please Select Bin Number File.",
  pleaseEnterCardType: "Please enter Card Type",
  addCardTypeManually: "Add Card Type Manually",
  userJourneyFlow: "User Journey Flow",
  searchMovie: "Search Movie",
  selectFoodAndBeverages: "Select Food and Beverages",
  enterFoodandBeverages: "Enter food and beverages",
  businessStartTime: "Business Start Time",
  businessEndTime: "Business End Time",
  blockPricing: "Block Pricing",
  blockPricingTooltip:
    "The customer can purchase the ticket in a group of 10 or 20 or 30 if block pricing is activated. If it is inactive, customers can purchase individual tickets",
  movieRateCard: "Movie Rate Card | Movie Rate Cards",
  manageMovieRateCardHere: "Manage all movie rate cards",
  action: "Action",

  // 24 Sep
  cinemaTerritory_tooltip: "The Territory in which the cinema is located",
  locationTooltip: "The location of the Cinema",
  regionTooltip: "The region of the Cinema",
  currentcyTooltip: "The currency accepted by the Cinema",
  tierTypeTooltip: "Tier type of the Cinema",
  cinemaClassificationTooltip:
    "The categories in which the Cinema is classified into",
  cinemaTypeTooltip: "The type of the Cinema",
  seatTypeSeatimage_tooltip: "The image of the Seat Type",
  unpaidBooking: "Unpaid Bookings",
  reserved: "Reserved",
  showType: "Show Type",
  collapse: "Collapse",

  videoFormatError: "Movie Content Type not supported",
  soundFormatError: "Movie Sound Format not supported",
  videoFormatErrorPopup: "Screen does not support selected movies content type",
  soundFormatErrorPopup: "Screen does not support selected movies sound format",
  licenseDateError: "Movie License Date not set or expired",
  licenseDateErrorPopup: "Warning: Movie License Date not set or expired",
  licenseDatePastError: "Movie License Date expired",
  licenseDatePastErrorPopup: "Warning: Movie License Date expired",
  licenseDateExpiresBeforeScheduleError:
    "Movie License Date will expire before last schedule date",
  licenseDateExpiresBeforeScheduleErrorPopup:
    "Warning: Movie License Date will expire before last schedule date",
  openVoucher: "Open Voucher",
  is_share_with_distributor: "Share With Distributor",
  is_complimentary_ticket: "Complimentary Ticket",
  is_code_required: "Voucher Code Required",
  complemetory: "Complimentary",
  complementory_modal_titel: "Select Complimentary Tickets",
  voucher_not_available: "Not Available",
  VoucherCodeDeounce: "Voucher Code",
  print: "Print Ticket",
  macs: "MACCS",
  comment: "Comment",
  transaction_id: "Transaction Id",
  kiosk_cutoff_time: "Kiosk CutOff Time",
  website_cutoff_time: "Website CutOff Time",
  POS_cutoff_time: "POS CutOff Time",
  Pos_new: "Pos",
  Kiosk_new: "Kiosk",
  website_new: "Website",
  allow_cash_refund: "Allow Cash Refund",
  first_name: "First Name",
  last_name: "Last Name",
  maccs_box_cd: "MACCS BOX CD",
  distributor_maccs_id: "Distributor Maccs ID",
  refund_done: "Refunded",
  maccs_status: "MACCS Status",
  ml_type_label: "Select Label Type",
  key_valid_from: "Key Valid From",
  key_valid_to: "Key Valid To",
  KDM: "KDM",
  money: "Money",
  cash_card_topup: "Add Cash",
  cash_card_number: "Cash Card",
  cust_email: "Email",
  cust_mobile: "Contact",
  topup: "Add Cash",
  balance_amount: "Current Balance",
  pay_using_cash_card: "Pay",
  prefix: "Prefix",
  random_card_number: "Code",
  suffix: "Suffix",
  pin: "Pin",
  issuer: "Issuer",
  cash_card_reason: "Reason",
  add_money: "Add Cash",
  debit_cash: "Deduct Cash",
  save_n_generate: "Save & Generate",
  last_transaction: "Last Transaction",
  export: "Export as",
  sell_cash_card: "Sell Cash Card",
  street_sale: "Street Sale",
  add_customer_details: "Add Customer",
  apply_filter: "Apply",
  amount_update_by: "Added/Deducted By",
  closing_balance: "Closing Balance",
  card_generate_at: "Card Generated At",
  fnbOrder: "FNB Order",
  category_type: "Category Type",
  serial_order: "S.No",
  earliest_bday: "Earliest Bday",
  showing_content_in_language: "Showing content in Language",
  parent_movie: "Parent Movie",
  parent_version: "Parent Version",
  cash_card_gallery: "Cash Card Gallery",
  list_of_all_online_cash_card: "List of all Online Cash Card Images",
  w_cash_card_name: "Cash Card Name",
  w_cash_card_image: "Cash Card Image",
  w_professing_fee: "Processing Fee",
  w_minimum_topup: "Minimum Value",
  cash_card_transactions: "Website Cash Card Purchase",
  online_cc_dash_msg: "List of Cash Cards Purchased Online",
  reservation_id: "Reservation Id",
  card_status: "Card Status",
  delivery_date: "Estimated Delivery Date",
  card_generate_on: "Card Type",
  guest_user: "Guest User Name",
  scheduleOverview: "Schedule Overview",
  cinemaOverviewReport: "Show Overview",
  timeleft: "Time left",
  Addon_charges_dash_msg: "Movie Addon charges",
  addon_amount: "Additional Charges",
  age_limit: "Age Limit",
  global_options_dash_msg: "All Global Settings",
  send_to_maccs: "Send to Maccs",
  srt_multi_select: "Seat Multi Select",
  weekWithNoShow: "Week with No Schedule",
  distributorSummary: "Distributor Summary",
  distributorDetailedSummary: "Distributor Detailed Report",
  oldGrossPrice: "Old Price",
  newGrossPrice: "New Price",
  autoentered: "Auto Entered",
  loyalityOffers: "Loyality Program",
  subscribeloyality: "Subscribe loyality",
  hardwareLocations: "Hardware Locations",
  hardwareLocations_dash: "List of All Hardware Locations",
  fixedPriceTicketFnb: "Fixed Price Ticket/FNB",
  combinewithfnb: "Combine FNB",
  atFlatRate: "at",
  Each: "Each",
  buyAndgetOffOnAnother: "Buy one And Get Off On Another",
  buyAndgetOffOnAnother_des: "Ticket And Get",
  buyAndgetOffOnAnother_des2: "On Another Ticket",
  isReadyToServe: "Ready To Serve Item",
  referralCode: "Referral Code | Referral Codes",
  referralCode_dash_msg: "List of all Referral Codes",
  is_premier_item: "Premier Item",
  payByMeritGCModal: "Pay By Merit Gift Card",
};



// WEBPACK FOOTER //
// ./src/helper/ln/en.js